import {MockData} from '@testhelper/mock-data';

export class ServiceDataMock {
  static getServiceData(): any[] {
    return [
      {
        organization: MockData.organization,
        name: 'kykelikokos',
        number: '81549300',
        initComponent: 4,
        posX: 10,
        posY: 19,
        installDate: new Date(1506006381000),
        pattern: 2,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'provider',
        creationTime: new Date(1506006381000),
        componentMap: {
          0: {},
          4: {
            serviceNumber: '81549300',
            id: 4,
            type: 'CustomDate',
            name: 'Calendar Holidays',
            posX: 353,
            posY: 19,
            customizable: true
          },
          5: {
            serviceNumber: '81549300',
            id: 5,
            type: 'TimeRouter',
            name: 'Opening Hours',
            posX: 551,
            posY: 19,
            customizable: true
          },
          20: {
            customizable: true,
            id: 20,
            name: 'Outside OpeningHours Profile',
            posX: 381,
            posY: 228,
            serviceNumber: '81549300',
            type: 'CustomSwitch'
          },
          23: {
            customizable: true,
            id: 23,
            name: 'Termination',
            posX: 381,
            posY: 228,
            serviceNumber: '81549300',
            type: 'Termination'
          },
          39: {
            customizable: true,
            id: 39,
            name: 'CallBackQueue',
            posX: 381,
            posY: 228,
            serviceNumber: '81549300',
            type: 'CallbackQueue'
          },
          26: {
            customizable: true,
            id: 26,
            name: 'Unanswered calls profile',
            posX: -1,
            posY: 2218,
            serviceNumber: '81549300',
            type: 'CustomSwitch'
          },
          61: {
            customizable: true,
            id: 61,
            name: 'Temporary message',
            posX: -1,
            posY: 2218,
            serviceNumber: '81549300',
            type: 'CustomSwitch'
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'Mainnumber',
        number: '4737179231',
        initComponent: 4,
        posX: 7,
        posY: 11,
        installDate: 1573124946000,
        pattern: 1,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1573114596000,
        componentMap: {
          0: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231',
            id: 0,
            type: 'Termination',
            name: 'Default Service',
            posX: 892,
            posY: 9,
            customizable: true,
            displayMode: 5,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4737179231001',
            breleaseCall: false
          },
          4: {
            '@type': 'CustomDateModule',
            serviceNumber: '4737179231',
            id: 4,
            type: 'CustomDate',
            name: 'Calendar Holidays',
            posX: 351,
            posY: 11,
            customizable: true,
            dateEntries: [],
            legalNextComponents: [
              {
                cid: 20,
                displayName: null
              }
            ],
            defaultNextCid: 5
          },
          5: {
            '@type': 'TimeRouterModule',
            serviceNumber: '4737179231',
            id: 5,
            type: 'TimeRouter',
            name: 'Opening Hours',
            posX: 549,
            posY: 11,
            customizable: true,
            timeRouterEntries: [
              {
                dayOfWeek: 1,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 2,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 3,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 4,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 5,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 6,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 7,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              }
            ],
            legalNextComponents: [
              {
                cid: 0,
                displayName: null
              },
              {
                cid: 43,
                displayName: null
              }
            ],
            defaultNextCid: 20
          },
          6: {
            '@type': 'PromptModule',
            serviceNumber: '4737179231',
            id: 6,
            type: 'Prompt',
            name: 'Switchboard closed message',
            posX: 139,
            posY: 562,
            customizable: true,
            messageName: '../officeclosed.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          20: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4737179231',
            id: 20,
            type: 'CustomSwitch',
            name: 'Outside OpeningHours Profile',
            posX: 354,
            posY: 337,
            customizable: true,
            legalNextComponents: [
              {
                cid: 6,
                displayName: 'Closed Announcement'
              },
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: null
              },
              {
                cid: 24,
                displayName: 'Phone number'
              },
              {
                cid: 25,
                displayName: 'Company Extension or Group'
              },
              {
                cid: 31,
                displayName: null
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 6,
            stateCid: 31
          },
          22: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231',
            id: 22,
            type: 'Termination',
            name: 'Autoattendant',
            posX: 658,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4737179231003',
            breleaseCall: false
          },
          23: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231',
            id: 23,
            type: 'Termination',
            name: 'Member Voicemail',
            posX: 762,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791509001',
            breleaseCall: false
          },
          24: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231',
            id: 24,
            type: 'Termination',
            name: 'Colleague Number',
            posX: 887,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          25: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231',
            id: 25,
            type: 'Termination',
            name: 'CompanyExt',
            posX: 318,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          31: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231',
            id: 31,
            type: 'Termination',
            name: 'Queue',
            posX: 57,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          40: {
            '@type': 'PromptModule',
            serviceNumber: '4737179231',
            id: 40,
            type: 'Prompt',
            name: 'CompanyVMMessage',
            posX: 385,
            posY: 465,
            customizable: true,
            messageName: '../Bedriftens_VMS.wav',
            nextCid: 41,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          41: {
            '@type': 'Component',
            serviceNumber: '4737179231',
            id: 41,
            type: 'Record',
            name: 'VMRecord',
            posX: 417,
            posY: 611,
            customizable: false
          },
          42: {
            '@type': 'SendMessageModule',
            serviceNumber: '4737179231',
            id: 42,
            type: 'SendMessage',
            name: 'SendEmail',
            posX: 521,
            posY: 607,
            customizable: true,
            protocol: 1,
            delay: 30,
            frequency: 300,
            toAddressExpression: 'dan.lewi.harkestad@@gintel.com',
            fromFullNameExpression: 'Dipper Sentralbord',
            fromAddressExpression: 'ikke-svar@@sb.dipper.no',
            subjectExpression: 'Bedriftens talepostkasse fra Dipper, ny melding fra +@a',
            contentExpression:
              'Du har en melding fra +@a som ringte nummer @B, vennligst se vedlegg.@N@NMeldingen ble mottatt: @D @T@N@NDette er en automatisk generert melding, det er ikke mulig å svare på e-posten.@N@NFor hjelp og tilbakemelding, kontakt kundeservice: https://dipper.no/kundeservice.@N@NHilsen Dipper.',
            attachementPathExpression: '/mnt/rec_share/@a_@B_@d@t.wav',
            daysBeforeExpire: 1,
            nextCid: null,
            errorCid: null
          },
          43: {
            '@type': 'Component',
            serviceNumber: '4737179231',
            id: 43,
            type: 'Screen',
            name: 'Screen',
            posX: 913,
            posY: 200,
            customizable: false
          },
          44: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231',
            id: 44,
            type: 'Termination',
            name: 'Continue',
            posX: 1083,
            posY: 197,
            customizable: false,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 1,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '@e',
            breleaseCall: false
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'Hovednummer',
        number: '4723905197',
        initComponent: 4,
        posX: 7,
        posY: 11,
        installDate: 1605778060000,
        pattern: 1,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1552574933000,
        componentMap: {
          0: {
            '@type': 'TerminationModule',
            serviceNumber: '4723905197',
            id: 0,
            type: 'Termination',
            name: 'Default Service',
            posX: 892,
            posY: 9,
            customizable: true,
            displayMode: 5,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4737179231001',
            breleaseCall: false
          },
          4: {
            '@type': 'CustomDateModule',
            serviceNumber: '4723905197',
            id: 4,
            type: 'CustomDate',
            name: 'Calendar Holidays',
            posX: 351,
            posY: 11,
            customizable: true,
            dateEntries: [],
            legalNextComponents: [
              {
                cid: 20,
                displayName: null
              }
            ],
            defaultNextCid: 5
          },
          5: {
            '@type': 'TimeRouterModule',
            serviceNumber: '4723905197',
            id: 5,
            type: 'TimeRouter',
            name: 'Opening Hours',
            posX: 549,
            posY: 11,
            customizable: true,
            timeRouterEntries: [
              {
                dayOfWeek: 1,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 3,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 4,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 5,
                startHour: 0,
                startMin: 0,
                duration: 1260,
                nextCid: 43
              },
              {
                dayOfWeek: 6,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 7,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              }
            ],
            legalNextComponents: [
              {
                cid: 0,
                displayName: null
              },
              {
                cid: 43,
                displayName: null
              }
            ],
            defaultNextCid: 20
          },
          6: {
            '@type': 'PromptModule',
            serviceNumber: '4723905197',
            id: 6,
            type: 'Prompt',
            name: 'Switchboard closed message',
            posX: 139,
            posY: 562,
            customizable: true,
            messageName: '../officeclosed.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          20: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4723905197',
            id: 20,
            type: 'CustomSwitch',
            name: 'Outside OpeningHours Profile',
            posX: 354,
            posY: 337,
            customizable: true,
            legalNextComponents: [
              {
                cid: 6,
                displayName: 'Closed Announcement'
              },
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: null
              },
              {
                cid: 24,
                displayName: 'Phone number'
              },
              {
                cid: 25,
                displayName: 'Company Extension or Group'
              },
              {
                cid: 31,
                displayName: null
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 6,
            stateCid: 23
          },
          22: {
            '@type': 'TerminationModule',
            serviceNumber: '4723905197',
            id: 22,
            type: 'Termination',
            name: 'Autoattendant',
            posX: 658,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4723905197001',
            breleaseCall: false
          },
          23: {
            '@type': 'TerminationModule',
            serviceNumber: '4723905197',
            id: 23,
            type: 'Termination',
            name: 'Member Voicemail',
            posX: 762,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: '4746180301',
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791509001',
            breleaseCall: false
          },
          24: {
            '@type': 'TerminationModule',
            serviceNumber: '4723905197',
            id: 24,
            type: 'Termination',
            name: 'Colleague Number',
            posX: 887,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: 'null',
            breleaseCall: false
          },
          25: {
            '@type': 'TerminationModule',
            serviceNumber: '4723905197',
            id: 25,
            type: 'Termination',
            name: 'CompanyExt',
            posX: 318,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4746180285',
            breleaseCall: false
          },
          31: {
            '@type': 'TerminationModule',
            serviceNumber: '4723905197',
            id: 31,
            type: 'Termination',
            name: 'Queue',
            posX: 57,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4772909430',
            breleaseCall: false
          },
          40: {
            '@type': 'PromptModule',
            serviceNumber: '4723905197',
            id: 40,
            type: 'Prompt',
            name: 'CompanyVMMessage',
            posX: 385,
            posY: 465,
            customizable: true,
            messageName: '../Bedriftens_VMS.wav',
            nextCid: 41,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          41: {
            '@type': 'Component',
            serviceNumber: '4723905197',
            id: 41,
            type: 'Record',
            name: 'VMRecord',
            posX: 417,
            posY: 611,
            customizable: false
          },
          42: {
            '@type': 'SendMessageModule',
            serviceNumber: '4723905197',
            id: 42,
            type: 'SendMessage',
            name: 'SendEmail',
            posX: 521,
            posY: 607,
            customizable: true,
            protocol: 1,
            delay: 30,
            frequency: 300,
            toAddressExpression: 'priya@@gintel.com',
            fromFullNameExpression: 'Dipper Sentralbord',
            fromAddressExpression: 'ikke-svar@@sb.dipper.no',
            subjectExpression: 'Bedriftens talepostkasse fra Dipper, ny melding fra +@a',
            contentExpression:
              'Du har en melding fra +@a som ringte nummer @B, vennligst se vedlegg.@N@NMeldingen ble mottatt: @D @T@N@NDette er en automatisk generert melding, det er ikke mulig å svare på e-posten.@N@NFor hjelp og tilbakemelding, kontakt kundeservice: https://dipper.no/kundeservice.@N@NHilsen Dipper.',
            attachementPathExpression: '/mnt/rec_share/@a_@B_@d@t.wav',
            daysBeforeExpire: 1,
            nextCid: null,
            errorCid: null
          },
          43: {
            '@type': 'Component',
            serviceNumber: '4723905197',
            id: 43,
            type: 'Screen',
            name: 'Screen',
            posX: 913,
            posY: 200,
            customizable: false
          },
          44: {
            '@type': 'TerminationModule',
            serviceNumber: '4723905197',
            id: 44,
            type: 'Termination',
            name: 'Continue',
            posX: 1083,
            posY: 197,
            customizable: false,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 1,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '@e',
            breleaseCall: false
          },
          47: {
            '@type': 'TerminationModule',
            serviceNumber: '4723905197',
            id: 47,
            type: 'Termination',
            name: '47 CustomTermination',
            posX: 187,
            posY: 156,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4746180301',
            breleaseCall: false
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'Screening',
        number: '4722535028008',
        initComponent: 0,
        posX: 40,
        posY: 277,
        installDate: 1600950630000,
        pattern: 9,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1600950630000,
        componentMap: {
          0: {
            '@type': 'CustomMapperModule',
            serviceNumber: '4722535028008',
            id: 0,
            type: 'CustomMapper',
            name: 'Black/Whitelist',
            posX: 260,
            posY: 269,
            customizable: true,
            mapType: 1,
            matchExact: false,
            resultIsCid: false,
            matchNextCid: 1,
            noMatchNextCid: 6,
            errorNextCid: 6,
            showKey: null,
            showValue: null,
            showKind: null,
            showStatId: null,
            showDate: null,
            showLogin: null,
            customerMapperEntries: [
              {
                mapKey: '91906314',
                mapValue: 'Telenor VIP',
                kind: null,
                statId: null,
                dateChanged: 1600898400000,
                login: '91902493'
              }
            ]
          },
          1: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4722535028008',
            id: 1,
            type: 'CustomSwitch',
            name: 'In List Profile',
            posX: 431,
            posY: 153,
            customizable: true,
            legalNextComponents: [
              {
                cid: 2,
                displayName: null
              },
              {
                cid: 3,
                displayName: null
              },
              {
                cid: 4,
                displayName: null
              },
              {
                cid: 5,
                displayName: null
              }
            ],
            defaultNextCid: null,
            stateCid: 5
          },
          2: {
            '@type': 'PromptModule',
            serviceNumber: '4722535028008',
            id: 2,
            type: 'Prompt',
            name: 'In list Message',
            posX: 634,
            posY: 53,
            customizable: true,
            messageName: '',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          3: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028008',
            id: 3,
            type: 'Termination',
            name: 'In list CompanyExt',
            posX: 694,
            posY: 110,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          4: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028008',
            id: 4,
            type: 'Termination',
            name: 'In list AutoAttendant',
            posX: 691,
            posY: 198,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          5: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028008',
            id: 5,
            type: 'Termination',
            name: 'In list AnswerGroup',
            posX: 607,
            posY: 260,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4778974938',
            breleaseCall: false
          },
          6: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4722535028008',
            id: 6,
            type: 'CustomSwitch',
            name: 'Not in list profile',
            posX: 449,
            posY: 471,
            customizable: true,
            legalNextComponents: [
              {
                cid: 7,
                displayName: null
              },
              {
                cid: 8,
                displayName: null
              },
              {
                cid: 9,
                displayName: null
              },
              {
                cid: 10,
                displayName: null
              }
            ],
            defaultNextCid: null,
            stateCid: 7
          },
          7: {
            '@type': 'PromptModule',
            serviceNumber: '4722535028008',
            id: 7,
            type: 'Prompt',
            name: 'Not in list Message',
            posX: 650,
            posY: 359,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/FullQueue.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          8: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028008',
            id: 8,
            type: 'Termination',
            name: 'Not in list CompanyExt',
            posX: 716,
            posY: 437,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          9: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028008',
            id: 9,
            type: 'Termination',
            name: 'Not in list AnswerGroup',
            posX: 642,
            posY: 628,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          10: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028008',
            id: 10,
            type: 'Termination',
            name: 'Not in list AutoAttendant',
            posX: 710,
            posY: 546,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'Screening',
        number: '4722535028007',
        initComponent: 0,
        posX: 40,
        posY: 277,
        installDate: 1600941623000,
        pattern: 9,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1600941623000,
        componentMap: {
          0: {
            '@type': 'CustomMapperModule',
            serviceNumber: '4722535028007',
            id: 0,
            type: 'CustomMapper',
            name: 'Black/Whitelist',
            posX: 260,
            posY: 269,
            customizable: true,
            mapType: 1,
            matchExact: false,
            resultIsCid: false,
            matchNextCid: 1,
            noMatchNextCid: 6,
            errorNextCid: 6,
            showKey: null,
            showValue: null,
            showKind: null,
            showStatId: null,
            showDate: null,
            showLogin: null,
            customerMapperEntries: [
              {
                mapKey: '45230057',
                mapValue: 'Test',
                kind: null,
                statId: null,
                dateChanged: 1600898400000,
                login: '91902493'
              }
            ]
          },
          1: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4722535028007',
            id: 1,
            type: 'CustomSwitch',
            name: 'In List Profile',
            posX: 431,
            posY: 153,
            customizable: true,
            legalNextComponents: [
              {
                cid: 2,
                displayName: null
              },
              {
                cid: 3,
                displayName: null
              },
              {
                cid: 4,
                displayName: null
              },
              {
                cid: 5,
                displayName: null
              }
            ],
            defaultNextCid: null,
            stateCid: 3
          },
          2: {
            '@type': 'PromptModule',
            serviceNumber: '4722535028007',
            id: 2,
            type: 'Prompt',
            name: 'In list Message',
            posX: 634,
            posY: 53,
            customizable: true,
            messageName: '',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          3: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028007',
            id: 3,
            type: 'Termination',
            name: 'In list CompanyExt',
            posX: 694,
            posY: 110,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791905129',
            breleaseCall: false
          },
          4: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028007',
            id: 4,
            type: 'Termination',
            name: 'In list AutoAttendant',
            posX: 691,
            posY: 198,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          5: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028007',
            id: 5,
            type: 'Termination',
            name: 'In list AnswerGroup',
            posX: 607,
            posY: 260,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          6: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4722535028007',
            id: 6,
            type: 'CustomSwitch',
            name: 'Not in list profile',
            posX: 449,
            posY: 471,
            customizable: true,
            legalNextComponents: [
              {
                cid: 7,
                displayName: null
              },
              {
                cid: 8,
                displayName: null
              },
              {
                cid: 9,
                displayName: null
              },
              {
                cid: 10,
                displayName: null
              }
            ],
            defaultNextCid: null,
            stateCid: 10
          },
          7: {
            '@type': 'PromptModule',
            serviceNumber: '4722535028007',
            id: 7,
            type: 'Prompt',
            name: 'Not in list Message',
            posX: 650,
            posY: 359,
            customizable: true,
            messageName: '',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          8: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028007',
            id: 8,
            type: 'Termination',
            name: 'Not in list CompanyExt',
            posX: 716,
            posY: 437,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          9: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028007',
            id: 9,
            type: 'Termination',
            name: 'Not in list AnswerGroup',
            posX: 642,
            posY: 628,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          10: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028007',
            id: 10,
            type: 'Termination',
            name: 'Not in list AutoAttendant',
            posX: 710,
            posY: 546,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4778974938',
            breleaseCall: false
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'Hoved IMG Hoved IMG 22535028',
        number: '4722535028',
        initComponent: 4,
        posX: 7,
        posY: 11,
        installDate: 1573727961000,
        pattern: 1,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1573727961000,
        componentMap: {
          0: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028',
            id: 0,
            type: 'Termination',
            name: 'Default Service',
            posX: 892,
            posY: 9,
            customizable: true,
            displayMode: 5,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            breleaseCall: false,
            cnumber: '4778974972'
          },
          4: {
            '@type': 'CustomDateModule',
            serviceNumber: '4722535028',
            id: 4,
            type: 'CustomDate',
            name: 'Calendar Holidays',
            posX: 351,
            posY: 11,
            customizable: true,
            dateEntries: [],
            legalNextComponents: [
              {
                cid: 20,
                displayName: null
              }
            ],
            defaultNextCid: 5
          },
          5: {
            '@type': 'TimeRouterModule',
            serviceNumber: '4722535028',
            id: 5,
            type: 'TimeRouter',
            name: 'Opening Hours',
            posX: 549,
            posY: 11,
            customizable: true,
            timeRouterEntries: [
              {
                dayOfWeek: 3,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 4,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 5,
                startHour: 0,
                startMin: 0,
                duration: 1260,
                nextCid: 43
              },
              {
                dayOfWeek: 1,
                startHour: 8,
                startMin: 0,
                duration: 840,
                nextCid: 43
              },
              {
                dayOfWeek: 2,
                startHour: 8,
                startMin: 0,
                duration: 480,
                nextCid: 43
              }
            ],
            legalNextComponents: [
              {
                cid: 0,
                displayName: null
              },
              {
                cid: 43,
                displayName: null
              }
            ],
            defaultNextCid: 20
          },
          6: {
            '@type': 'PromptModule',
            serviceNumber: '4722535028',
            id: 6,
            type: 'Prompt',
            name: 'Switchboard closed message',
            posX: 139,
            posY: 562,
            customizable: true,
            messageName: '../officeclosed.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          20: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4722535028',
            id: 20,
            type: 'CustomSwitch',
            name: 'Outside OpeningHours Profile',
            posX: 354,
            posY: 337,
            customizable: true,
            legalNextComponents: [
              {
                cid: 6,
                displayName: 'Closed Announcement'
              },
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: null
              },
              {
                cid: 24,
                displayName: 'Phone number'
              },
              {
                cid: 25,
                displayName: 'Company Extension or Group'
              },
              {
                cid: 31,
                displayName: null
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 6,
            stateCid: 25
          },
          22: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028',
            id: 22,
            type: 'Termination',
            name: 'Autoattendant',
            posX: 658,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            breleaseCall: false,
            cnumber: '4737179231001'
          },
          23: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028',
            id: 23,
            type: 'Termination',
            name: 'Member Voicemail',
            posX: 762,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: '4791903248',
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            breleaseCall: false,
            cnumber: '4791509001'
          },
          24: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028',
            id: 24,
            type: 'Termination',
            name: 'Colleague Number',
            posX: 887,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            breleaseCall: false,
            cnumber: 'null'
          },
          25: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028',
            id: 25,
            type: 'Termination',
            name: 'CompanyExt',
            posX: 318,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            breleaseCall: false,
            cnumber: '4791903884'
          },
          31: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028',
            id: 31,
            type: 'Termination',
            name: 'Queue',
            posX: 57,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            breleaseCall: false,
            cnumber: '4770238871'
          },
          40: {
            '@type': 'PromptModule',
            serviceNumber: '4722535028',
            id: 40,
            type: 'Prompt',
            name: 'CompanyVMMessage',
            posX: 385,
            posY: 465,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/FullQueueFw.wav',
            nextCid: 41,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          41: {
            '@type': 'Component',
            serviceNumber: '4722535028',
            id: 41,
            type: 'Record',
            name: 'VMRecord',
            posX: 417,
            posY: 611,
            customizable: false
          },
          42: {
            '@type': 'SendMessageModule',
            serviceNumber: '4722535028',
            id: 42,
            type: 'SendMessage',
            name: 'SendEmail',
            posX: 521,
            posY: 607,
            customizable: true,
            protocol: 1,
            delay: 30,
            frequency: 300,
            toAddressExpression: 'priya@@gintel.com',
            fromFullNameExpression: 'Dipper Sentralbord',
            fromAddressExpression: 'ikke-svar@@sb.dipper.no',
            subjectExpression: 'Bedriftens talepostkasse fra Dipper, ny melding fra +@a',
            contentExpression:
              'Du har en melding fra +@a som ringte nummer @B, vennligst se vedlegg.@N@NMeldingen ble mottatt: @D @T@N@NDette er en automatisk generert melding, det er ikke mulig å svare på e-posten.@N@NFor hjelp og tilbakemelding, kontakt kundeservice: https://dipper.no/kundeservice.@N@NHilsen Dipper.',
            attachementPathExpression: '/mnt/rec_share/@a_@B_@d@t.wav',
            daysBeforeExpire: 1,
            nextCid: null,
            errorCid: null
          },
          43: {
            '@type': 'Component',
            serviceNumber: '4722535028',
            id: 43,
            type: 'Screen',
            name: 'Screen',
            posX: 913,
            posY: 200,
            customizable: false
          },
          44: {
            '@type': 'TerminationModule',
            serviceNumber: '4722535028',
            id: 44,
            type: 'Termination',
            name: 'Continue',
            posX: 1083,
            posY: 197,
            customizable: false,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 1,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            breleaseCall: false,
            cnumber: '@e'
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'Tastevalg 1',
        number: '4737179231001',
        initComponent: 0,
        posX: 50,
        posY: 50,
        installDate: 1601906162000,
        pattern: 7,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1601906162000,
        componentMap: {
          0: {
            '@type': 'PromptAndCollectModule',
            serviceNumber: '4737179231001',
            id: 0,
            type: 'PromptAndCollect',
            name: 'Hovedmeny',
            posX: 336,
            posY: 102,
            customizable: true,
            promptAndCollectEntries: [
              {
                digits: '0',
                nextCid: 0,
                statId: null,
                webType: null
              },
              {
                digits: '1',
                nextCid: 1,
                statId: null,
                webType: 4
              },
              {
                digits: '2',
                nextCid: 2,
                statId: null,
                webType: 3
              },
              {
                digits: '3',
                nextCid: 3,
                statId: null,
                webType: 1
              },
              {
                digits: '4',
                nextCid: 4,
                statId: null,
                webType: 11
              },
              {
                digits: '6',
                nextCid: 6,
                statId: null,
                webType: 7
              }
            ],
            nextCid: 2,
            startIndicator: 1,
            repeatIndicator: 0,
            numberOfDigits: 1,
            maxReceiveTime: 60,
            terminateDigit: null,
            firstDigitTime: 15,
            nextDigitTime: 10,
            messageName: '../menu.wav',
            errorCid: null,
            toFewDigitsCid: null,
            disconnectACid: null,
            language: null
          },
          1: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001',
            id: 1,
            type: 'Termination',
            name: null,
            posX: null,
            posY: null,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 60,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: null,
            suppressRedirectInfo: null,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791902493',
            breleaseCall: false
          },
          2: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001',
            id: 2,
            type: 'Termination',
            name: null,
            posX: null,
            posY: null,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 60,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: null,
            suppressRedirectInfo: null,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4770238871',
            breleaseCall: false
          },
          3: {
            '@type': 'PromptModule',
            serviceNumber: '4737179231001',
            id: 3,
            type: 'Prompt',
            name: null,
            posX: null,
            posY: null,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/hqmusic.wav',
            nextCid: null,
            repeatIndicator: null,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          4: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001',
            id: 4,
            type: 'Termination',
            name: null,
            posX: null,
            posY: null,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 60,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: null,
            suppressRedirectInfo: null,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4737179231001002',
            breleaseCall: false
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'Tastevalg 3',
        number: '4737179231001001',
        initComponent: 0,
        posX: 50,
        posY: 50,
        installDate: 1602504407000,
        pattern: 7,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1602504407000,
        componentMap: {
          0: {
            '@type': 'PromptAndCollectModule',
            serviceNumber: '4737179231001001',
            id: 0,
            type: 'PromptAndCollect',
            name: 'Hovedmeny',
            posX: 336,
            posY: 102,
            customizable: true,
            promptAndCollectEntries: [
              {
                digits: '0',
                nextCid: 0,
                statId: null,
                webType: null
              }
            ],
            nextCid: 0,
            startIndicator: 1,
            repeatIndicator: 0,
            numberOfDigits: 1,
            maxReceiveTime: 60,
            terminateDigit: null,
            firstDigitTime: 15,
            nextDigitTime: 10,
            messageName: '../menu.wav',
            errorCid: null,
            toFewDigitsCid: null,
            disconnectACid: null,
            language: null
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'VIP-liste',
        number: '4737179231001002',
        initComponent: 0,
        posX: 40,
        posY: 277,
        installDate: 1602665051000,
        pattern: 9,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1602665051000,
        componentMap: {
          0: {
            '@type': 'CustomMapperModule',
            serviceNumber: '4737179231001002',
            id: 0,
            type: 'CustomMapper',
            name: 'Black/Whitelist',
            posX: 260,
            posY: 269,
            customizable: true,
            mapType: 1,
            matchExact: false,
            resultIsCid: false,
            matchNextCid: 1,
            noMatchNextCid: 6,
            errorNextCid: 6,
            showKey: null,
            showValue: null,
            showKind: null,
            showStatId: null,
            showDate: null,
            showLogin: null,
            customerMapperEntries: [
              {
                mapKey: '111',
                mapValue: '111',
                kind: null,
                statId: null,
                dateChanged: 1631052000000,
                login: '91902156'
              },
              {
                mapKey: '1234',
                mapValue: null,
                kind: null,
                statId: null,
                dateChanged: 1631052000000,
                login: '91902156'
              },
              {
                mapKey: '4791906314',
                mapValue: 'special number',
                kind: null,
                statId: null,
                dateChanged: 1614898800000,
                login: 'gtsupport'
              }
            ]
          },
          1: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4737179231001002',
            id: 1,
            type: 'CustomSwitch',
            name: 'In List Profile',
            posX: 431,
            posY: 153,
            customizable: true,
            legalNextComponents: [
              {
                cid: 2,
                displayName: null
              },
              {
                cid: 3,
                displayName: null
              },
              {
                cid: 4,
                displayName: null
              },
              {
                cid: 5,
                displayName: null
              }
            ],
            defaultNextCid: null,
            stateCid: 2
          },
          2: {
            '@type': 'PromptModule',
            serviceNumber: '4737179231001002',
            id: 2,
            type: 'Prompt',
            name: 'In list Message',
            posX: 634,
            posY: 53,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/file1MG.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          3: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001002',
            id: 3,
            type: 'Termination',
            name: 'In list CompanyExt',
            posX: 694,
            posY: 110,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4794057650',
            breleaseCall: false
          },
          4: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001002',
            id: 4,
            type: 'Termination',
            name: 'In list AutoAttendant',
            posX: 691,
            posY: 198,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          5: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001002',
            id: 5,
            type: 'Termination',
            name: 'In list AnswerGroup',
            posX: 607,
            posY: 260,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          6: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4737179231001002',
            id: 6,
            type: 'CustomSwitch',
            name: 'Not in list profile',
            posX: 449,
            posY: 471,
            customizable: true,
            legalNextComponents: [
              {
                cid: 7,
                displayName: null
              },
              {
                cid: 8,
                displayName: null
              },
              {
                cid: 9,
                displayName: null
              },
              {
                cid: 10,
                displayName: null
              }
            ],
            defaultNextCid: null,
            stateCid: 7
          },
          7: {
            '@type': 'PromptModule',
            serviceNumber: '4737179231001002',
            id: 7,
            type: 'Prompt',
            name: 'Not in list Message',
            posX: 650,
            posY: 359,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/Ingenagenter.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          8: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001002',
            id: 8,
            type: 'Termination',
            name: 'Not in list CompanyExt',
            posX: 716,
            posY: 437,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          9: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001002',
            id: 9,
            type: 'Termination',
            name: 'Not in list AnswerGroup',
            posX: 642,
            posY: 628,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          10: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001002',
            id: 10,
            type: 'Termination',
            name: 'Not in list AutoAttendant',
            posX: 710,
            posY: 546,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'VIP-liste',
        number: '4737179231001003',
        initComponent: 0,
        posX: 40,
        posY: 277,
        installDate: 1602666633000,
        pattern: 9,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1602666633000,
        componentMap: {
          0: {
            '@type': 'CustomMapperModule',
            serviceNumber: '4737179231001003',
            id: 0,
            type: 'CustomMapper',
            name: 'Black/Whitelist',
            posX: 260,
            posY: 269,
            customizable: true,
            mapType: 1,
            matchExact: false,
            resultIsCid: false,
            matchNextCid: 1,
            noMatchNextCid: 6,
            errorNextCid: 6,
            showKey: null,
            showValue: null,
            showKind: null,
            showStatId: null,
            showDate: null,
            showLogin: null,
            customerMapperEntries: []
          },
          1: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4737179231001003',
            id: 1,
            type: 'CustomSwitch',
            name: 'In List Profile',
            posX: 431,
            posY: 153,
            customizable: true,
            legalNextComponents: [
              {
                cid: 2,
                displayName: null
              },
              {
                cid: 3,
                displayName: null
              },
              {
                cid: 4,
                displayName: null
              },
              {
                cid: 5,
                displayName: null
              }
            ],
            defaultNextCid: null,
            stateCid: null
          },
          2: {
            '@type': 'PromptModule',
            serviceNumber: '4737179231001003',
            id: 2,
            type: 'Prompt',
            name: 'In list Message',
            posX: 634,
            posY: 53,
            customizable: true,
            messageName: '',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          3: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001003',
            id: 3,
            type: 'Termination',
            name: 'In list CompanyExt',
            posX: 694,
            posY: 110,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          4: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001003',
            id: 4,
            type: 'Termination',
            name: 'In list AutoAttendant',
            posX: 691,
            posY: 198,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          5: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001003',
            id: 5,
            type: 'Termination',
            name: 'In list AnswerGroup',
            posX: 607,
            posY: 260,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          6: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4737179231001003',
            id: 6,
            type: 'CustomSwitch',
            name: 'Not in list profile',
            posX: 449,
            posY: 471,
            customizable: true,
            legalNextComponents: [
              {
                cid: 7,
                displayName: null
              },
              {
                cid: 8,
                displayName: null
              },
              {
                cid: 9,
                displayName: null
              },
              {
                cid: 10,
                displayName: null
              }
            ],
            defaultNextCid: null,
            stateCid: null
          },
          7: {
            '@type': 'PromptModule',
            serviceNumber: '4737179231001003',
            id: 7,
            type: 'Prompt',
            name: 'Not in list Message',
            posX: 650,
            posY: 359,
            customizable: true,
            messageName: '',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          8: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001003',
            id: 8,
            type: 'Termination',
            name: 'Not in list CompanyExt',
            posX: 716,
            posY: 437,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          9: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001003',
            id: 9,
            type: 'Termination',
            name: 'Not in list AnswerGroup',
            posX: 642,
            posY: 628,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          10: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001003',
            id: 10,
            type: 'Termination',
            name: 'Not in list AutoAttendant',
            posX: 710,
            posY: 546,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'VIP-liste',
        number: '4737179231001004',
        initComponent: 0,
        posX: 40,
        posY: 277,
        installDate: 1602666693000,
        pattern: 9,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1602666693000,
        componentMap: {
          0: {
            '@type': 'CustomMapperModule',
            serviceNumber: '4737179231001004',
            id: 0,
            type: 'CustomMapper',
            name: 'Black/Whitelist',
            posX: 260,
            posY: 269,
            customizable: true,
            mapType: 1,
            matchExact: false,
            resultIsCid: false,
            matchNextCid: 1,
            noMatchNextCid: 6,
            errorNextCid: 6,
            showKey: null,
            showValue: null,
            showKind: null,
            showStatId: null,
            showDate: null,
            showLogin: null,
            customerMapperEntries: []
          },
          1: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4737179231001004',
            id: 1,
            type: 'CustomSwitch',
            name: 'In List Profile',
            posX: 431,
            posY: 153,
            customizable: true,
            legalNextComponents: [
              {
                cid: 2,
                displayName: null
              },
              {
                cid: 3,
                displayName: null
              },
              {
                cid: 4,
                displayName: null
              },
              {
                cid: 5,
                displayName: null
              }
            ],
            defaultNextCid: null,
            stateCid: null
          },
          2: {
            '@type': 'PromptModule',
            serviceNumber: '4737179231001004',
            id: 2,
            type: 'Prompt',
            name: 'In list Message',
            posX: 634,
            posY: 53,
            customizable: true,
            messageName: '',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          3: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001004',
            id: 3,
            type: 'Termination',
            name: 'In list CompanyExt',
            posX: 694,
            posY: 110,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          4: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001004',
            id: 4,
            type: 'Termination',
            name: 'In list AutoAttendant',
            posX: 691,
            posY: 198,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          5: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001004',
            id: 5,
            type: 'Termination',
            name: 'In list AnswerGroup',
            posX: 607,
            posY: 260,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          6: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4737179231001004',
            id: 6,
            type: 'CustomSwitch',
            name: 'Not in list profile',
            posX: 449,
            posY: 471,
            customizable: true,
            legalNextComponents: [
              {
                cid: 7,
                displayName: null
              },
              {
                cid: 8,
                displayName: null
              },
              {
                cid: 9,
                displayName: null
              },
              {
                cid: 10,
                displayName: null
              }
            ],
            defaultNextCid: null,
            stateCid: null
          },
          7: {
            '@type': 'PromptModule',
            serviceNumber: '4737179231001004',
            id: 7,
            type: 'Prompt',
            name: 'Not in list Message',
            posX: 650,
            posY: 359,
            customizable: true,
            messageName: '',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          8: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001004',
            id: 8,
            type: 'Termination',
            name: 'Not in list CompanyExt',
            posX: 716,
            posY: 437,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          9: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001004',
            id: 9,
            type: 'Termination',
            name: 'Not in list AnswerGroup',
            posX: 642,
            posY: 628,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          10: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231001004',
            id: 10,
            type: 'Termination',
            name: 'Not in list AutoAttendant',
            posX: 710,
            posY: 546,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'Tastevalg_78403123',
        number: '4737179231002',
        initComponent: 0,
        posX: 50,
        posY: 50,
        installDate: 1602504855000,
        pattern: 7,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1602504855000,
        componentMap: {
          0: {
            '@type': 'PromptAndCollectModule',
            serviceNumber: '4737179231002',
            id: 0,
            type: 'PromptAndCollect',
            name: 'Hovedmeny',
            posX: 336,
            posY: 102,
            customizable: true,
            promptAndCollectEntries: [
              {
                digits: '0',
                nextCid: 0,
                statId: null,
                webType: null
              },
              {
                digits: '1',
                nextCid: 1,
                statId: null,
                webType: 1
              },
              {
                digits: '2',
                nextCid: 2,
                statId: null,
                webType: 4
              },
              {
                digits: '3',
                nextCid: 3,
                statId: null,
                webType: 3
              }
            ],
            nextCid: 0,
            startIndicator: 1,
            repeatIndicator: 0,
            numberOfDigits: 1,
            maxReceiveTime: 60,
            terminateDigit: null,
            firstDigitTime: 15,
            nextDigitTime: 10,
            messageName: '../menu.wav',
            errorCid: null,
            toFewDigitsCid: null,
            disconnectACid: null,
            language: null
          },
          1: {
            '@type': 'PromptModule',
            serviceNumber: '4737179231002',
            id: 1,
            type: 'Prompt',
            name: null,
            posX: null,
            posY: null,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/Ingenagenter.wav',
            nextCid: null,
            repeatIndicator: null,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          2: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231002',
            id: 2,
            type: 'Termination',
            name: null,
            posX: null,
            posY: null,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 60,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: null,
            suppressRedirectInfo: null,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791902955',
            breleaseCall: false
          },
          3: {
            '@type': 'TerminationModule',
            serviceNumber: '4737179231002',
            id: 3,
            type: 'Termination',
            name: null,
            posX: null,
            posY: null,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 60,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: null,
            suppressRedirectInfo: null,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4770238871',
            breleaseCall: false
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'Tastevalg 5',
        number: '4737179231003',
        initComponent: 0,
        posX: 50,
        posY: 50,
        installDate: 1602509422000,
        pattern: 7,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1602509422000,
        componentMap: {
          0: {
            '@type': 'PromptAndCollectModule',
            serviceNumber: '4737179231003',
            id: 0,
            type: 'PromptAndCollect',
            name: 'Hovedmeny',
            posX: 336,
            posY: 102,
            customizable: true,
            promptAndCollectEntries: [
              {
                digits: '0',
                nextCid: 0,
                statId: null,
                webType: null
              }
            ],
            nextCid: 0,
            startIndicator: 1,
            repeatIndicator: 0,
            numberOfDigits: 1,
            maxReceiveTime: 60,
            terminateDigit: null,
            firstDigitTime: 15,
            nextDigitTime: 10,
            messageName: '../menu.wav',
            errorCid: null,
            toFewDigitsCid: null,
            disconnectACid: null,
            language: null
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'Test-MH',
        number: '4744556677',
        initComponent: 4,
        posX: 7,
        posY: 11,
        installDate: 1629813331000,
        pattern: 1,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1629813331000,
        componentMap: {
          0: {
            '@type': 'TerminationModule',
            serviceNumber: '4744556677',
            id: 0,
            type: 'Termination',
            name: 'Default Service',
            posX: 892,
            posY: 9,
            customizable: true,
            displayMode: 5,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          4: {
            '@type': 'CustomDateModule',
            serviceNumber: '4744556677',
            id: 4,
            type: 'CustomDate',
            name: 'Calendar Holidays',
            posX: 351,
            posY: 11,
            customizable: true,
            dateEntries: [],
            legalNextComponents: [
              {
                cid: 20,
                displayName: null
              }
            ],
            defaultNextCid: 5
          },
          5: {
            '@type': 'TimeRouterModule',
            serviceNumber: '4744556677',
            id: 5,
            type: 'TimeRouter',
            name: 'Opening Hours',
            posX: 549,
            posY: 11,
            customizable: true,
            timeRouterEntries: [
              {
                dayOfWeek: 1,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 2,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 3,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 4,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 5,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 6,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 7,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              }
            ],
            legalNextComponents: [
              {
                cid: 0,
                displayName: null
              },
              {
                cid: 43,
                displayName: null
              }
            ],
            defaultNextCid: 20
          },
          6: {
            '@type': 'PromptModule',
            serviceNumber: '4744556677',
            id: 6,
            type: 'Prompt',
            name: 'Switchboard closed message',
            posX: 139,
            posY: 562,
            customizable: true,
            messageName: '../officeclosed.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          20: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4744556677',
            id: 20,
            type: 'CustomSwitch',
            name: 'Outside OpeningHours Profile',
            posX: 354,
            posY: 337,
            customizable: true,
            legalNextComponents: [
              {
                cid: 6,
                displayName: 'Closed Announcement'
              },
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: null
              },
              {
                cid: 24,
                displayName: 'Phone number'
              },
              {
                cid: 25,
                displayName: 'Company Extension or Group'
              },
              {
                cid: 31,
                displayName: null
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 6,
            stateCid: null
          },
          22: {
            '@type': 'TerminationModule',
            serviceNumber: '4744556677',
            id: 22,
            type: 'Termination',
            name: 'Autoattendant',
            posX: 658,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          23: {
            '@type': 'TerminationModule',
            serviceNumber: '4744556677',
            id: 23,
            type: 'Termination',
            name: 'Member Voicemail',
            posX: 762,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791509001',
            breleaseCall: false
          },
          24: {
            '@type': 'TerminationModule',
            serviceNumber: '4744556677',
            id: 24,
            type: 'Termination',
            name: 'Colleague Number',
            posX: 887,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          25: {
            '@type': 'TerminationModule',
            serviceNumber: '4744556677',
            id: 25,
            type: 'Termination',
            name: 'CompanyExt',
            posX: 318,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          31: {
            '@type': 'TerminationModule',
            serviceNumber: '4744556677',
            id: 31,
            type: 'Termination',
            name: 'Queue',
            posX: 57,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          40: {
            '@type': 'PromptModule',
            serviceNumber: '4744556677',
            id: 40,
            type: 'Prompt',
            name: 'CompanyVMMessage',
            posX: 385,
            posY: 465,
            customizable: true,
            messageName: '../Bedriftens_VMS.wav',
            nextCid: 41,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          41: {
            '@type': 'Component',
            serviceNumber: '4744556677',
            id: 41,
            type: 'Record',
            name: 'VMRecord',
            posX: 417,
            posY: 611,
            customizable: false
          },
          42: {
            '@type': 'SendMessageModule',
            serviceNumber: '4744556677',
            id: 42,
            type: 'SendMessage',
            name: 'SendEmail',
            posX: 521,
            posY: 607,
            customizable: true,
            protocol: 1,
            delay: 30,
            frequency: 300,
            toAddressExpression: null,
            fromFullNameExpression: 'Dipper Sentralbord',
            fromAddressExpression: 'ikke-svar@@sb.dipper.no',
            subjectExpression: 'Bedriftens talepostkasse fra Dipper, ny melding fra +@a',
            contentExpression:
              'Du har en melding fra +@a som ringte nummer @B, vennligst se vedlegg.@N@NMeldingen ble mottatt: @D @T@N@NDette er en automatisk generert melding, det er ikke mulig å svare på e-posten.@N@NFor hjelp og tilbakemelding, kontakt kundeservice: https://dipper.no/kundeservice.@N@NHilsen Dipper.',
            attachementPathExpression: '/mnt/rec_share/@a_@B_@d@t.wav',
            daysBeforeExpire: 1,
            nextCid: null,
            errorCid: null
          },
          43: {
            '@type': 'Component',
            serviceNumber: '4744556677',
            id: 43,
            type: 'Screen',
            name: 'Screen',
            posX: 913,
            posY: 200,
            customizable: false
          },
          44: {
            '@type': 'TerminationModule',
            serviceNumber: '4744556677',
            id: 44,
            type: 'Termination',
            name: 'Continue',
            posX: 1083,
            posY: 197,
            customizable: false,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 1,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '@e',
            breleaseCall: false
          }
        }
      },
      {
        organization: MockData.organization,
        name: '12-digit-AG',
        number: '47580002020998',
        initComponent: 4,
        posX: 10,
        posY: 19,
        installDate: 1585208506000,
        pattern: 2,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1585208506000,
        componentMap: {
          0: {
            '@type': 'QueueModule',
            serviceNumber: '47580002020998',
            id: 0,
            type: 'Queue',
            name: '12-digit-AG',
            posX: 884,
            posY: 19,
            customizable: true,
            messageSequences: [
              {
                seqNo: 1,
                messageName: '../silence.wav',
                description: 'dummy',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              },
              {
                seqNo: 2,
                messageName: '../welcome.wav',
                description: 'welcome',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              },
              {
                seqNo: 3,
                messageName: '../qmusic.wav',
                description: 'music',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              },
              {
                seqNo: 4,
                messageName: '../periodical.wav',
                description: 'periodical',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              }
            ],
            queueFullCid: 26,
            kickoutTimeCid: 26,
            kickoutNoAgentsCid: 26,
            ivrErrorCid: null,
            maxPositions: 10,
            maxTime: 300,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 120,
            displayUpdateFrequency: 30,
            bnoAnaOrig: 210,
            noReplyTime: 25,
            chargingString: '511',
            noConnectFlags: 4095,
            agentDisplayMode: 5,
            disconnectACid: null,
            disconnectBCid: null,
            disconnectNotAnsweredCid: null,
            pauseCid: null,
            pauseTime: null,
            pauseRepeat: false,
            svcDegreeTime: 60,
            language: null,
            maxConnectTime: null,
            agentWarningTime: null,
            agentIntroMessage: null,
            callerIntroMessage: false,
            transferDisplayMode: null,
            dtmfCharacter: null,
            dtmfInConversationCid: null,
            dtmfInQueueCid: null,
            transferFailedCid: null,
            freeAgentOnTransfer: true,
            recordCall: false,
            recordCallFilename: null,
            agentSearchBackground: true,
            parallel: 0,
            huntType: 2,
            tempUnavailableTimeout: null,
            huntIterations: 1,
            smsWhenLoggOff: null,
            maxMissedCounter: null,
            huntActionMissed: 0,
            transferMessage: null,
            bctDisplayMode: -1,
            huntFailedCid: null,
            rejectCid: 26,
            rejectType: 0,
            genericNumberDisplayExpression: null,
            bctDisplayExpression: null,
            transferDisplayExpression: null,
            alarmTime: 120,
            alarmLength: 5,
            alarmRejectEnabled: true,
            alarmKickoutEnabled: true,
            alarmLastAgentEnabled: true,
            alarmFirstAgentEnabled: true,
            alarmRecipients: '4791902955',
            cnumber: '22399126'
          },
          3: {
            '@type': 'QueueModule',
            serviceNumber: '47580002020998',
            id: 3,
            type: 'Queue',
            name: 'Holdqueue',
            posX: 825,
            posY: 320,
            customizable: true,
            messageSequences: [
              {
                seqNo: 1,
                messageName: '../qmusic.wav',
                description: 'music',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 1
              }
            ],
            queueFullCid: 0,
            kickoutTimeCid: 0,
            kickoutNoAgentsCid: null,
            ivrErrorCid: null,
            maxPositions: 10,
            maxTime: 300,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 9999,
            displayUpdateFrequency: 30,
            bnoAnaOrig: 210,
            noReplyTime: 20,
            chargingString: '511',
            noConnectFlags: 4095,
            agentDisplayMode: 5,
            disconnectACid: null,
            disconnectBCid: null,
            disconnectNotAnsweredCid: null,
            pauseCid: null,
            pauseTime: null,
            pauseRepeat: false,
            svcDegreeTime: 60,
            language: null,
            maxConnectTime: null,
            agentWarningTime: null,
            agentIntroMessage: null,
            callerIntroMessage: false,
            transferDisplayMode: 2,
            dtmfCharacter: null,
            dtmfInConversationCid: null,
            dtmfInQueueCid: null,
            transferFailedCid: null,
            freeAgentOnTransfer: true,
            recordCall: false,
            recordCallFilename: null,
            agentSearchBackground: false,
            parallel: 2,
            huntType: 0,
            tempUnavailableTimeout: 30,
            huntIterations: 1,
            smsWhenLoggOff: null,
            maxMissedCounter: null,
            huntActionMissed: 0,
            transferMessage: null,
            bctDisplayMode: -1,
            huntFailedCid: null,
            rejectCid: null,
            rejectType: null,
            genericNumberDisplayExpression: null,
            bctDisplayExpression: null,
            transferDisplayExpression: null,
            alarmTime: 0,
            alarmLength: 0,
            alarmRejectEnabled: false,
            alarmKickoutEnabled: false,
            alarmLastAgentEnabled: false,
            alarmFirstAgentEnabled: false,
            alarmRecipients: '',
            cnumber: '22399126'
          },
          4: {
            '@type': 'CustomDateModule',
            serviceNumber: '47580002020998',
            id: 4,
            type: 'CustomDate',
            name: 'Calendar Holidays',
            posX: 353,
            posY: 19,
            customizable: true,
            dateEntries: [],
            legalNextComponents: [
              {
                cid: 20,
                displayName: null
              }
            ],
            defaultNextCid: 5
          },
          5: {
            '@type': 'TimeRouterModule',
            serviceNumber: '47580002020998',
            id: 5,
            type: 'TimeRouter',
            name: 'Opening Hours',
            posX: 551,
            posY: 19,
            customizable: true,
            timeRouterEntries: [
              {
                dayOfWeek: 1,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 2,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 3,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 4,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 5,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 6,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 7,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              }
            ],
            legalNextComponents: [
              {
                cid: 22,
                displayName: null
              },
              {
                cid: 35,
                displayName: null
              }
            ],
            defaultNextCid: 20
          },
          6: {
            '@type': 'PromptModule',
            serviceNumber: '47580002020998',
            id: 6,
            type: 'Prompt',
            name: 'Switchboard closed message',
            posX: 68,
            posY: 607,
            customizable: true,
            messageName: '../officeclosed.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          20: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '47580002020998',
            id: 20,
            type: 'CustomSwitch',
            name: 'Outside OpeningHours Profile',
            posX: 381,
            posY: 228,
            customizable: true,
            legalNextComponents: [
              {
                cid: 6,
                displayName: 'Closed Announcement'
              },
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: 'Member Voicemail'
              },
              {
                cid: 24,
                displayName: 'Phone number'
              },
              {
                cid: 25,
                displayName: 'Company Extension or Group'
              },
              {
                cid: 31,
                displayName: null
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 6,
            stateCid: 6
          },
          22: {
            '@type': 'TerminationModule',
            serviceNumber: '47580002020998',
            id: 22,
            type: 'Termination',
            name: 'Choice',
            posX: 626,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          23: {
            '@type': 'TerminationModule',
            serviceNumber: '47580002020998',
            id: 23,
            type: 'Termination',
            name: 'redirect user vmx on no reply',
            posX: 710,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791509001',
            breleaseCall: false
          },
          24: {
            '@type': 'TerminationModule',
            serviceNumber: '47580002020998',
            id: 24,
            type: 'Termination',
            name: 'Redirect external vmx number',
            posX: 822,
            posY: 623,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          25: {
            '@type': 'TerminationModule',
            serviceNumber: '47580002020998',
            id: 25,
            type: 'Termination',
            name: 'CompanyExt',
            posX: 261,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 1,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          26: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '47580002020998',
            id: 26,
            type: 'CustomSwitch',
            name: 'Overflow Profile',
            posX: 973,
            posY: 343,
            customizable: true,
            legalNextComponents: [
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: 'Member Voicemail'
              },
              {
                cid: 29,
                displayName: 'Closed Announcement'
              },
              {
                cid: 30,
                displayName: 'Phone number'
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 29,
            stateCid: 29
          },
          29: {
            '@type': 'PromptModule',
            serviceNumber: '47580002020998',
            id: 29,
            type: 'Prompt',
            name: 'Ubesvart - talemelding',
            posX: 1022,
            posY: 623,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/15m_brownian.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          30: {
            '@type': 'TerminationModule',
            serviceNumber: '47580002020998',
            id: 30,
            type: 'Termination',
            name: 'Overflow Phonenumber redirect',
            posX: 1124,
            posY: 623,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          31: {
            '@type': 'TerminationModule',
            serviceNumber: '47580002020998',
            id: 31,
            type: 'Termination',
            name: 'Different answergroup',
            posX: 0,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          32: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '47580002020998',
            id: 32,
            type: 'CustomSwitch',
            name: 'Include welcome',
            posX: 693,
            posY: 136,
            customizable: true,
            legalNextComponents: [
              {
                cid: 0,
                displayName: null
              }
            ],
            defaultNextCid: 0,
            stateCid: 0
          },
          33: {
            '@type': 'PromptModule',
            serviceNumber: '47580002020998',
            id: 33,
            type: 'Prompt',
            name: 'Welcome message',
            posX: 685,
            posY: 256,
            customizable: true,
            messageName: '../welcome.wav',
            nextCid: 0,
            repeatIndicator: 0,
            errorCid: 0,
            disconnectACid: null,
            language: null,
            early: null
          },
          35: {
            '@type': 'Component',
            serviceNumber: '47580002020998',
            id: 35,
            type: 'IntLookup',
            name: 'RedirFromAnotherQueue',
            posX: 670,
            posY: 19,
            customizable: false
          },
          36: {
            '@type': 'Component',
            serviceNumber: '47580002020998',
            id: 36,
            type: 'IntLookup',
            name: 'CheckValidANumber',
            posX: 1208,
            posY: 21,
            customizable: false
          },
          37: {
            '@type': 'PromptAndCollectModule',
            serviceNumber: '47580002020998',
            id: 37,
            type: 'PromptAndCollect',
            name: 'ChoiceCallBackUser',
            posX: 1202,
            posY: 174,
            customizable: false,
            promptAndCollectEntries: [
              {
                digits: '1',
                nextCid: 38,
                statId: null,
                webType: null
              }
            ],
            nextCid: 0,
            startIndicator: 1,
            repeatIndicator: 0,
            numberOfDigits: 1,
            maxReceiveTime: 60,
            terminateDigit: null,
            firstDigitTime: 10,
            nextDigitTime: 10,
            messageName: '../CB_tast1.wav',
            errorCid: 0,
            toFewDigitsCid: 0,
            disconnectACid: null,
            language: null
          },
          38: {
            '@type': 'PromptModule',
            serviceNumber: '47580002020998',
            id: 38,
            type: 'Prompt',
            name: 'callback message',
            posX: 1204,
            posY: 287,
            customizable: false,
            messageName: '../Takk_vi_ringer_deg.wav',
            nextCid: 39,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          39: {
            '@type': 'Component',
            serviceNumber: '47580002020998',
            id: 39,
            type: 'CallbackQueue',
            name: 'CallbackQueue',
            posX: 1217,
            posY: 431,
            customizable: false
          },
          40: {
            '@type': 'PromptModule',
            serviceNumber: '47580002020998',
            id: 40,
            type: 'Prompt',
            name: 'Bedriftens mobilsvar',
            posX: 386,
            posY: 466,
            customizable: true,
            messageName: '../Bedriftens_VMS.wav',
            nextCid: 41,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          41: {
            '@type': 'Component',
            serviceNumber: '47580002020998',
            id: 41,
            type: 'Record',
            name: 'record company vmx',
            posX: 415,
            posY: 605,
            customizable: false
          },
          42: {
            '@type': 'SendMessageModule',
            serviceNumber: '47580002020998',
            id: 42,
            type: 'SendMessage',
            name: 'Bedriftens mobilsvar',
            posX: 521,
            posY: 607,
            customizable: true,
            protocol: 1,
            delay: 30,
            frequency: 300,
            toAddressExpression: '',
            fromFullNameExpression: 'Dipper Sentralbord',
            fromAddressExpression: 'ikke-svar@@sb.dipper.no',
            subjectExpression: 'Bedriftens talepostkasse fra Dipper, ny melding fra +@a',
            contentExpression:
              'Du har en melding fra +@a, vennligst se vedlegg.@N@NMeldingen ble mottatt: @D @T@N@NDette er en automatisk generert melding, det er ikke mulig å svare på e-posten.@N@NFor hjelp og tilbakemelding, kontakt kundeservice: https://dipper.no/kundeservice.@N@NHilsen Dipper.',
            attachementPathExpression: '/mnt/rec_share/@a_@B_@d@t.wav',
            daysBeforeExpire: 1,
            nextCid: null,
            errorCid: null
          },
          43: {
            '@type': 'SendSmsModule',
            serviceNumber: '47580002020998',
            id: 43,
            type: 'SendSMS',
            name: '43 SendSMS',
            posX: 1345,
            posY: 406,
            customizable: true,
            source: '',
            displaySource: '',
            destination: '@A',
            message: '',
            nextCid: null,
            errorCid: null
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'Ninja1',
        number: '4770238717',
        initComponent: 4,
        posX: 10,
        posY: 19,
        installDate: 1583925110000,
        pattern: 2,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1583925110000,
        componentMap: {
          0: {
            '@type': 'QueueModule',
            serviceNumber: '4770238717',
            id: 0,
            type: 'Queue',
            name: 'Ninja1',
            posX: 884,
            posY: 19,
            customizable: true,
            messageSequences: [
              {
                seqNo: 1,
                messageName: '../silence.wav',
                description: 'dummy',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              },
              {
                seqNo: 2,
                messageName: '../welcome.wav',
                description: 'welcome',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              },
              {
                seqNo: 3,
                messageName: '../ringingtone.wav',
                description: 'music',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              },
              {
                seqNo: 4,
                messageName: '../periodical.wav',
                description: 'periodical',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              }
            ],
            queueFullCid: 26,
            kickoutTimeCid: 26,
            kickoutNoAgentsCid: 26,
            ivrErrorCid: null,
            maxPositions: 0,
            maxTime: 300,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 120,
            displayUpdateFrequency: 30,
            bnoAnaOrig: 210,
            noReplyTime: 25,
            chargingString: '511',
            noConnectFlags: 4095,
            agentDisplayMode: 5,
            disconnectACid: null,
            disconnectBCid: null,
            disconnectNotAnsweredCid: null,
            pauseCid: null,
            pauseTime: null,
            pauseRepeat: false,
            svcDegreeTime: 60,
            language: null,
            maxConnectTime: null,
            agentWarningTime: null,
            agentIntroMessage: null,
            callerIntroMessage: false,
            transferDisplayMode: null,
            dtmfCharacter: null,
            dtmfInConversationCid: null,
            dtmfInQueueCid: null,
            transferFailedCid: null,
            freeAgentOnTransfer: true,
            recordCall: false,
            recordCallFilename: null,
            agentSearchBackground: true,
            parallel: 0,
            huntType: 3,
            tempUnavailableTimeout: null,
            huntIterations: 1,
            smsWhenLoggOff: null,
            maxMissedCounter: null,
            huntActionMissed: 0,
            transferMessage: null,
            bctDisplayMode: -1,
            huntFailedCid: null,
            rejectCid: 26,
            rejectType: -1,
            genericNumberDisplayExpression: null,
            bctDisplayExpression: null,
            transferDisplayExpression: null,
            alarmTime: 0,
            alarmLength: 0,
            alarmRejectEnabled: false,
            alarmKickoutEnabled: false,
            alarmLastAgentEnabled: false,
            alarmFirstAgentEnabled: false,
            alarmRecipients: '4791902955',
            cnumber: '22399126'
          },
          3: {
            '@type': 'QueueModule',
            serviceNumber: '4770238717',
            id: 3,
            type: 'Queue',
            name: 'Holdqueue',
            posX: 825,
            posY: 320,
            customizable: true,
            messageSequences: [
              {
                seqNo: 1,
                messageName: '../ringingtone.wav',
                description: 'music',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 1
              }
            ],
            queueFullCid: 0,
            kickoutTimeCid: 0,
            kickoutNoAgentsCid: null,
            ivrErrorCid: null,
            maxPositions: 10,
            maxTime: 300,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 9999,
            displayUpdateFrequency: 30,
            bnoAnaOrig: 210,
            noReplyTime: 20,
            chargingString: '511',
            noConnectFlags: 4095,
            agentDisplayMode: 5,
            disconnectACid: null,
            disconnectBCid: null,
            disconnectNotAnsweredCid: null,
            pauseCid: null,
            pauseTime: null,
            pauseRepeat: false,
            svcDegreeTime: 60,
            language: null,
            maxConnectTime: null,
            agentWarningTime: null,
            agentIntroMessage: null,
            callerIntroMessage: false,
            transferDisplayMode: 2,
            dtmfCharacter: null,
            dtmfInConversationCid: null,
            dtmfInQueueCid: null,
            transferFailedCid: null,
            freeAgentOnTransfer: true,
            recordCall: false,
            recordCallFilename: null,
            agentSearchBackground: false,
            parallel: 2,
            huntType: 0,
            tempUnavailableTimeout: 30,
            huntIterations: 1,
            smsWhenLoggOff: '',
            maxMissedCounter: null,
            huntActionMissed: 0,
            transferMessage: null,
            bctDisplayMode: -1,
            huntFailedCid: null,
            rejectCid: null,
            rejectType: null,
            genericNumberDisplayExpression: null,
            bctDisplayExpression: null,
            transferDisplayExpression: null,
            alarmTime: 0,
            alarmLength: 0,
            alarmRejectEnabled: false,
            alarmKickoutEnabled: false,
            alarmLastAgentEnabled: false,
            alarmFirstAgentEnabled: false,
            alarmRecipients: '',
            cnumber: '22399126'
          },
          4: {
            '@type': 'CustomDateModule',
            serviceNumber: '4770238717',
            id: 4,
            type: 'CustomDate',
            name: 'Calendar Holidays',
            posX: 353,
            posY: 19,
            customizable: true,
            dateEntries: [],
            legalNextComponents: [
              {
                cid: 20,
                displayName: null
              }
            ],
            defaultNextCid: 5
          },
          5: {
            '@type': 'TimeRouterModule',
            serviceNumber: '4770238717',
            id: 5,
            type: 'TimeRouter',
            name: 'Opening Hours',
            posX: 551,
            posY: 19,
            customizable: true,
            timeRouterEntries: [
              {
                dayOfWeek: 1,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 2,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 3,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 4,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 5,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 6,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 7,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              }
            ],
            legalNextComponents: [
              {
                cid: 22,
                displayName: null
              },
              {
                cid: 35,
                displayName: null
              }
            ],
            defaultNextCid: 20
          },
          6: {
            '@type': 'PromptModule',
            serviceNumber: '4770238717',
            id: 6,
            type: 'Prompt',
            name: 'Switchboard closed message',
            posX: 68,
            posY: 607,
            customizable: true,
            messageName: '../officeclosed.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          20: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4770238717',
            id: 20,
            type: 'CustomSwitch',
            name: 'Outside OpeningHours Profile',
            posX: 381,
            posY: 228,
            customizable: true,
            legalNextComponents: [
              {
                cid: 6,
                displayName: 'Closed Announcement'
              },
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: 'Member Voicemail'
              },
              {
                cid: 24,
                displayName: 'Phone number'
              },
              {
                cid: 25,
                displayName: 'Company Extension or Group'
              },
              {
                cid: 31,
                displayName: null
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 6,
            stateCid: 6
          },
          22: {
            '@type': 'TerminationModule',
            serviceNumber: '4770238717',
            id: 22,
            type: 'Termination',
            name: 'Choice',
            posX: 626,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4770238717002',
            breleaseCall: false
          },
          23: {
            '@type': 'TerminationModule',
            serviceNumber: '4770238717',
            id: 23,
            type: 'Termination',
            name: 'redirect user vmx on no reply',
            posX: 710,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: '4791901526',
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791509001',
            breleaseCall: false
          },
          24: {
            '@type': 'TerminationModule',
            serviceNumber: '4770238717',
            id: 24,
            type: 'Termination',
            name: 'Redirect external vmx number',
            posX: 822,
            posY: 623,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791902955',
            breleaseCall: false
          },
          25: {
            '@type': 'TerminationModule',
            serviceNumber: '4770238717',
            id: 25,
            type: 'Termination',
            name: 'CompanyExt',
            posX: 261,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 1,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791903248',
            breleaseCall: false
          },
          26: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4770238717',
            id: 26,
            type: 'CustomSwitch',
            name: 'Overflow Profile',
            posX: 973,
            posY: 343,
            customizable: true,
            legalNextComponents: [
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: 'Member Voicemail'
              },
              {
                cid: 29,
                displayName: 'Closed Announcement'
              },
              {
                cid: 30,
                displayName: 'Phone number'
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 29,
            stateCid: 29
          },
          29: {
            '@type': 'PromptModule',
            serviceNumber: '4770238717',
            id: 29,
            type: 'Prompt',
            name: 'Ubesvart - talemelding',
            posX: 1022,
            posY: 623,
            customizable: true,
            messageName: '../overflow.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          30: {
            '@type': 'TerminationModule',
            serviceNumber: '4770238717',
            id: 30,
            type: 'Termination',
            name: 'Overflow Phonenumber redirect',
            posX: 1124,
            posY: 623,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: 'null',
            breleaseCall: false
          },
          31: {
            '@type': 'TerminationModule',
            serviceNumber: '4770238717',
            id: 31,
            type: 'Termination',
            name: 'Different answergroup',
            posX: 0,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4778974937',
            breleaseCall: false
          },
          32: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4770238717',
            id: 32,
            type: 'CustomSwitch',
            name: 'Include welcome',
            posX: 693,
            posY: 136,
            customizable: true,
            legalNextComponents: [
              {
                cid: 0,
                displayName: null
              }
            ],
            defaultNextCid: 0,
            stateCid: 33
          },
          33: {
            '@type': 'PromptModule',
            serviceNumber: '4770238717',
            id: 33,
            type: 'Prompt',
            name: 'Welcome message',
            posX: 685,
            posY: 256,
            customizable: true,
            messageName: '../welcome.wav',
            nextCid: 0,
            repeatIndicator: 0,
            errorCid: 0,
            disconnectACid: null,
            language: null,
            early: null
          },
          35: {
            '@type': 'Component',
            serviceNumber: '4770238717',
            id: 35,
            type: 'IntLookup',
            name: 'RedirFromAnotherQueue',
            posX: 670,
            posY: 19,
            customizable: false
          },
          36: {
            '@type': 'Component',
            serviceNumber: '4770238717',
            id: 36,
            type: 'IntLookup',
            name: 'CheckValidANumber',
            posX: 1208,
            posY: 21,
            customizable: false
          },
          37: {
            '@type': 'PromptAndCollectModule',
            serviceNumber: '4770238717',
            id: 37,
            type: 'PromptAndCollect',
            name: 'ChoiceCallBackUser',
            posX: 1202,
            posY: 174,
            customizable: false,
            promptAndCollectEntries: [
              {
                digits: '1',
                nextCid: 38,
                statId: null,
                webType: null
              }
            ],
            nextCid: 0,
            startIndicator: 1,
            repeatIndicator: 0,
            numberOfDigits: 1,
            maxReceiveTime: 60,
            terminateDigit: null,
            firstDigitTime: 10,
            nextDigitTime: 10,
            messageName: '../CB_tast1.wav',
            errorCid: 0,
            toFewDigitsCid: 0,
            disconnectACid: null,
            language: null
          },
          38: {
            '@type': 'PromptModule',
            serviceNumber: '4770238717',
            id: 38,
            type: 'Prompt',
            name: 'callback message',
            posX: 1204,
            posY: 287,
            customizable: false,
            messageName: '../Takk_vi_ringer_deg.wav',
            nextCid: 39,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          39: {
            '@type': 'Component',
            serviceNumber: '4770238717',
            id: 39,
            type: 'CallbackQueue',
            name: 'CallbackQueue',
            posX: 1217,
            posY: 431,
            customizable: false
          },
          40: {
            '@type': 'PromptModule',
            serviceNumber: '4770238717',
            id: 40,
            type: 'Prompt',
            name: 'Bedriftens mobilsvar',
            posX: 386,
            posY: 466,
            customizable: true,
            messageName: '../Bedriftens_VMS.wav',
            nextCid: 41,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          41: {
            '@type': 'Component',
            serviceNumber: '4770238717',
            id: 41,
            type: 'Record',
            name: 'record company vmx',
            posX: 415,
            posY: 605,
            customizable: false
          },
          42: {
            '@type': 'SendMessageModule',
            serviceNumber: '4770238717',
            id: 42,
            type: 'SendMessage',
            name: 'Bedriftens mobilsvar',
            posX: 521,
            posY: 607,
            customizable: true,
            protocol: 1,
            delay: 30,
            frequency: 300,
            toAddressExpression: 'dan.lewi.harkestad@@gintel.com',
            fromFullNameExpression: 'Dipper Sentralbord',
            fromAddressExpression: 'ikke-svar@@sb.dipper.no',
            subjectExpression: 'Bedriftens talepostkasse fra Dipper, ny melding fra +@a',
            contentExpression:
              'Du har en melding fra +@a, vennligst se vedlegg.@N@NMeldingen ble mottatt: @D @T@N@NDette er en automatisk generert melding, det er ikke mulig å svare på e-posten.@N@NFor hjelp og tilbakemelding, kontakt kundeservice: https://dipper.no/kundeservice.@N@NHilsen Dipper.',
            attachementPathExpression: '/mnt/rec_share/@a_@B_@d@t.wav',
            daysBeforeExpire: 1,
            nextCid: null,
            errorCid: null
          },
          43: {
            '@type': 'SendSmsModule',
            serviceNumber: '4770238717',
            id: 43,
            type: 'SendSMS',
            name: '43 SendSMS',
            posX: 1345,
            posY: 406,
            customizable: true,
            source: '',
            displaySource: '',
            destination: '@A',
            message: '',
            nextCid: null,
            errorCid: null
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'Svargruppe_78403123',
        number: '4770238871',
        initComponent: 4,
        posX: 10,
        posY: 19,
        installDate: 1526636483000,
        pattern: 2,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1526023742000,
        componentMap: {
          0: {
            '@type': 'QueueModule',
            serviceNumber: '4770238871',
            id: 0,
            type: 'Queue',
            name: 'Svargruppe_78403123',
            posX: 884,
            posY: 19,
            customizable: true,
            messageSequences: [
              {
                seqNo: 1,
                messageName: '../silence.wav',
                description: 'dummy',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              },
              {
                seqNo: 2,
                messageName: '../welcome.wav',
                description: 'welcome',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              },
              {
                seqNo: 3,
                messageName: '../ringingtone.wav',
                description: 'music',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 4
              },
              {
                seqNo: 4,
                messageName: '../periodical.wav',
                description: 'periodical',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              }
            ],
            queueFullCid: 26,
            kickoutTimeCid: 26,
            kickoutNoAgentsCid: 26,
            ivrErrorCid: null,
            maxPositions: 10,
            maxTime: 300,
            checkFrequency: 30,
            kickoutTime: 300,
            kickoutNoAgents: 120,
            displayUpdateFrequency: 30,
            bnoAnaOrig: 210,
            noReplyTime: 25,
            chargingString: '511',
            noConnectFlags: 4095,
            agentDisplayMode: 5,
            disconnectACid: null,
            disconnectBCid: null,
            disconnectNotAnsweredCid: null,
            pauseCid: 36,
            pauseTime: 40,
            pauseRepeat: true,
            svcDegreeTime: 60,
            language: null,
            maxConnectTime: null,
            agentWarningTime: null,
            agentIntroMessage: null,
            callerIntroMessage: false,
            transferDisplayMode: 2,
            dtmfCharacter: null,
            dtmfInConversationCid: null,
            dtmfInQueueCid: null,
            transferFailedCid: null,
            freeAgentOnTransfer: true,
            recordCall: false,
            recordCallFilename: null,
            agentSearchBackground: true,
            parallel: 0,
            huntType: 2,
            tempUnavailableTimeout: null,
            huntIterations: 1,
            smsWhenLoggOff: null,
            maxMissedCounter: null,
            huntActionMissed: 0,
            transferMessage: null,
            bctDisplayMode: -1,
            huntFailedCid: null,
            rejectCid: 26,
            rejectType: 0,
            genericNumberDisplayExpression: null,
            bctDisplayExpression: null,
            transferDisplayExpression: null,
            alarmTime: 0,
            alarmLength: 0,
            alarmRejectEnabled: false,
            alarmKickoutEnabled: false,
            alarmLastAgentEnabled: false,
            alarmFirstAgentEnabled: false,
            alarmRecipients: '4791903248',
            cnumber: '22399126'
          },
          3: {
            '@type': 'QueueModule',
            serviceNumber: '4770238871',
            id: 3,
            type: 'Queue',
            name: 'Holdqueue',
            posX: 825,
            posY: 320,
            customizable: true,
            messageSequences: [
              {
                seqNo: 1,
                messageName: '../ringingtone.wav',
                description: 'music',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 1
              }
            ],
            queueFullCid: 0,
            kickoutTimeCid: 0,
            kickoutNoAgentsCid: null,
            ivrErrorCid: null,
            maxPositions: 10,
            maxTime: 300,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 9999,
            displayUpdateFrequency: 30,
            bnoAnaOrig: 210,
            noReplyTime: 20,
            chargingString: '511',
            noConnectFlags: 4095,
            agentDisplayMode: 5,
            disconnectACid: null,
            disconnectBCid: null,
            disconnectNotAnsweredCid: null,
            pauseCid: null,
            pauseTime: null,
            pauseRepeat: false,
            svcDegreeTime: 60,
            language: null,
            maxConnectTime: null,
            agentWarningTime: null,
            agentIntroMessage: null,
            callerIntroMessage: false,
            transferDisplayMode: 2,
            dtmfCharacter: null,
            dtmfInConversationCid: null,
            dtmfInQueueCid: null,
            transferFailedCid: null,
            freeAgentOnTransfer: true,
            recordCall: false,
            recordCallFilename: null,
            agentSearchBackground: false,
            parallel: 2,
            huntType: 0,
            tempUnavailableTimeout: 30,
            huntIterations: 1,
            smsWhenLoggOff: null,
            maxMissedCounter: null,
            huntActionMissed: 0,
            transferMessage: null,
            bctDisplayMode: -1,
            huntFailedCid: null,
            rejectCid: null,
            rejectType: null,
            genericNumberDisplayExpression: null,
            bctDisplayExpression: null,
            transferDisplayExpression: null,
            alarmTime: 0,
            alarmLength: 0,
            alarmRejectEnabled: false,
            alarmKickoutEnabled: false,
            alarmLastAgentEnabled: false,
            alarmFirstAgentEnabled: false,
            alarmRecipients: '',
            cnumber: '22399126'
          },
          4: {
            '@type': 'CustomDateModule',
            serviceNumber: '4770238871',
            id: 4,
            type: 'CustomDate',
            name: 'Calendar Holidays',
            posX: 353,
            posY: 19,
            customizable: true,
            dateEntries: [],
            legalNextComponents: [
              {
                cid: 20,
                displayName: null
              }
            ],
            defaultNextCid: 5
          },
          5: {
            '@type': 'TimeRouterModule',
            serviceNumber: '4770238871',
            id: 5,
            type: 'TimeRouter',
            name: 'Opening Hours',
            posX: 551,
            posY: 19,
            customizable: true,
            timeRouterEntries: [
              {
                dayOfWeek: 1,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 2,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 3,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 4,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 5,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 6,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 7,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              }
            ],
            legalNextComponents: [
              {
                cid: 22,
                displayName: null
              },
              {
                cid: 35,
                displayName: null
              }
            ],
            defaultNextCid: 20
          },
          6: {
            '@type': 'PromptModule',
            serviceNumber: '4770238871',
            id: 6,
            type: 'Prompt',
            name: 'Switchboard closed message',
            posX: 103,
            posY: 575,
            customizable: true,
            messageName: '../officeclosed.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          20: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4770238871',
            id: 20,
            type: 'CustomSwitch',
            name: 'Outside OpeningHours Profile',
            posX: 381,
            posY: 228,
            customizable: true,
            legalNextComponents: [
              {
                cid: 6,
                displayName: 'Closed Announcement'
              },
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: 'Member Voicemail'
              },
              {
                cid: 24,
                displayName: 'Phone number'
              },
              {
                cid: 25,
                displayName: 'Company Extension or Group'
              },
              {
                cid: 31,
                displayName: null
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 6,
            stateCid: null
          },
          22: {
            '@type': 'TerminationModule',
            serviceNumber: '4770238871',
            id: 22,
            type: 'Termination',
            name: 'Choice',
            posX: 626,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: null,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4770238871001',
            breleaseCall: false
          },
          23: {
            '@type': 'TerminationModule',
            serviceNumber: '4770238871',
            id: 23,
            type: 'Termination',
            name: 'redirect user vmx on no reply',
            posX: 710,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: '4791902955',
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: null,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791509001',
            breleaseCall: false
          },
          24: {
            '@type': 'TerminationModule',
            serviceNumber: '4770238871',
            id: 24,
            type: 'Termination',
            name: 'Redirect external vmx number',
            posX: 822,
            posY: 623,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: null,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          25: {
            '@type': 'TerminationModule',
            serviceNumber: '4770238871',
            id: 25,
            type: 'Termination',
            name: 'CompanyExt',
            posX: 261,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: null,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791902493',
            breleaseCall: false
          },
          26: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4770238871',
            id: 26,
            type: 'CustomSwitch',
            name: 'Overflow Profile',
            posX: 973,
            posY: 343,
            customizable: true,
            legalNextComponents: [
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: 'Member Voicemail'
              },
              {
                cid: 29,
                displayName: 'Closed Announcement'
              },
              {
                cid: 30,
                displayName: 'Phone number'
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 29,
            stateCid: 29
          },
          29: {
            '@type': 'PromptModule',
            serviceNumber: '4770238871',
            id: 29,
            type: 'Prompt',
            name: 'Ubesvart - talemelding',
            posX: 1022,
            posY: 623,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/Ingenagenter.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          30: {
            '@type': 'TerminationModule',
            serviceNumber: '4770238871',
            id: 30,
            type: 'Termination',
            name: 'Overflow Phonenumber redirect',
            posX: 1124,
            posY: 623,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: null,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: 'null',
            breleaseCall: false
          },
          31: {
            '@type': 'TerminationModule',
            serviceNumber: '4770238871',
            id: 31,
            type: 'Termination',
            name: 'Different answergroup',
            posX: 0,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: null,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4770238871',
            breleaseCall: false
          },
          32: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4770238871',
            id: 32,
            type: 'CustomSwitch',
            name: 'Include welcome',
            posX: 693,
            posY: 136,
            customizable: true,
            legalNextComponents: [
              {
                cid: 0,
                displayName: null
              }
            ],
            defaultNextCid: 0,
            stateCid: 33
          },
          33: {
            '@type': 'PromptModule',
            serviceNumber: '4770238871',
            id: 33,
            type: 'Prompt',
            name: 'Welcome message',
            posX: 685,
            posY: 256,
            customizable: true,
            messageName: '../welcome.wav',
            nextCid: 0,
            repeatIndicator: 0,
            errorCid: 0,
            disconnectACid: null,
            language: null,
            early: null
          },
          35: {
            '@type': 'Component',
            serviceNumber: '4770238871',
            id: 35,
            type: 'IntLookup',
            name: 'RedirFromAnotherQueue',
            posX: 670,
            posY: 19,
            customizable: false
          },
          36: {
            '@type': 'Component',
            serviceNumber: '4770238871',
            id: 36,
            type: 'IntLookup',
            name: 'CheckValidANumber',
            posX: 1208,
            posY: 21,
            customizable: false
          },
          37: {
            '@type': 'PromptAndCollectModule',
            serviceNumber: '4770238871',
            id: 37,
            type: 'PromptAndCollect',
            name: 'ChoiceCallBackUser',
            posX: 1202,
            posY: 174,
            customizable: false,
            promptAndCollectEntries: [
              {
                digits: '1',
                nextCid: 38,
                statId: null,
                webType: null
              }
            ],
            nextCid: 0,
            startIndicator: 1,
            repeatIndicator: 0,
            numberOfDigits: 1,
            maxReceiveTime: 60,
            terminateDigit: null,
            firstDigitTime: 10,
            nextDigitTime: 10,
            messageName: '../CB_tast1.wav',
            errorCid: 0,
            toFewDigitsCid: 0,
            disconnectACid: null,
            language: null
          },
          38: {
            '@type': 'PromptModule',
            serviceNumber: '4770238871',
            id: 38,
            type: 'Prompt',
            name: 'callback message',
            posX: 1204,
            posY: 287,
            customizable: false,
            messageName: '../Takk_vi_ringer_deg.wav',
            nextCid: 39,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          39: {
            '@type': 'Component',
            serviceNumber: '4770238871',
            id: 39,
            type: 'CallbackQueue',
            name: 'CallbackQueue',
            posX: 1217,
            posY: 431,
            customizable: false
          },
          40: {
            '@type': 'PromptModule',
            serviceNumber: '4770238871',
            id: 40,
            type: 'Prompt',
            name: 'Bedriftens mobilsvar',
            posX: 386,
            posY: 466,
            customizable: true,
            messageName: '../Bedriftens_VMS.wav',
            nextCid: 41,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          41: {
            '@type': 'Component',
            serviceNumber: '4770238871',
            id: 41,
            type: 'Record',
            name: 'record company vmx',
            posX: 385,
            posY: 619,
            customizable: false
          },
          42: {
            '@type': 'SendMessageModule',
            serviceNumber: '4770238871',
            id: 42,
            type: 'SendMessage',
            name: 'Bedriftens mobilsvar',
            posX: 460,
            posY: 746,
            customizable: true,
            protocol: 1,
            delay: 30,
            frequency: 300,
            toAddressExpression: 'priya@@gintel.com',
            fromFullNameExpression: 'Dipper Sentralbord',
            fromAddressExpression: 'ikke-svar@@sb.dipper.no',
            subjectExpression: 'Bedriftens talepostkasse fra Dipper, ny melding fra +@a',
            contentExpression:
              'Du har en melding fra +@a, vennligst se vedlegg.@N@NMeldingen ble mottatt: @D @T@N@NDette er en automatisk generert melding, det er ikke mulig å svare på e-posten.@N@NFor hjelp og tilbakemelding, kontakt kundeservice: https://dipper.no/kundeservice.@N@NHilsen Dipper.',
            attachementPathExpression: '/mnt/rec_share/@a_@B_@d@t.wav',
            daysBeforeExpire: 1,
            nextCid: null,
            errorCid: null
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'Tastevalg_12',
        number: '4770238871001',
        initComponent: 0,
        posX: 50,
        posY: 50,
        installDate: 1602501628000,
        pattern: 7,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1602501628000,
        componentMap: {
          0: {
            '@type': 'PromptAndCollectModule',
            serviceNumber: '4770238871001',
            id: 0,
            type: 'PromptAndCollect',
            name: 'Hovedmeny',
            posX: 336,
            posY: 102,
            customizable: true,
            promptAndCollectEntries: [
              {
                digits: '0',
                nextCid: 0,
                statId: null,
                webType: null
              },
              {
                digits: '1',
                nextCid: 1,
                statId: null,
                webType: 1
              },
              {
                digits: '2',
                nextCid: 2,
                statId: null,
                webType: 4
              },
              {
                digits: '3',
                nextCid: 3,
                statId: null,
                webType: 3
              }
            ],
            nextCid: 0,
            startIndicator: 1,
            repeatIndicator: 0,
            numberOfDigits: 1,
            maxReceiveTime: 60,
            terminateDigit: null,
            firstDigitTime: 15,
            nextDigitTime: 10,
            messageName: '../menu.wav',
            errorCid: null,
            toFewDigitsCid: null,
            disconnectACid: null,
            language: null
          },
          1: {
            '@type': 'PromptModule',
            serviceNumber: '4770238871001',
            id: 1,
            type: 'Prompt',
            name: null,
            posX: null,
            posY: null,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/Ingenagenter.wav',
            nextCid: null,
            repeatIndicator: null,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          2: {
            '@type': 'TerminationModule',
            serviceNumber: '4770238871001',
            id: 2,
            type: 'Termination',
            name: null,
            posX: null,
            posY: null,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 60,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: null,
            suppressRedirectInfo: null,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791902493',
            breleaseCall: false
          },
          3: {
            '@type': 'TerminationModule',
            serviceNumber: '4770238871001',
            id: 3,
            type: 'Termination',
            name: null,
            posX: null,
            posY: null,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 60,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: null,
            suppressRedirectInfo: null,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4770238871',
            breleaseCall: false
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'Hoved SIP_IC_4778403123',
        number: '4778403123',
        initComponent: 4,
        posX: 7,
        posY: 11,
        installDate: 1587600660000,
        pattern: 1,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1587600660000,
        componentMap: {
          0: {
            '@type': 'TerminationModule',
            serviceNumber: '4778403123',
            id: 0,
            type: 'Termination',
            name: 'Default Service',
            posX: 892,
            posY: 9,
            customizable: true,
            displayMode: 5,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4737179231001',
            breleaseCall: false
          },
          4: {
            '@type': 'CustomDateModule',
            serviceNumber: '4778403123',
            id: 4,
            type: 'CustomDate',
            name: 'Calendar Holidays',
            posX: 351,
            posY: 11,
            customizable: true,
            dateEntries: [],
            legalNextComponents: [
              {
                cid: 20,
                displayName: null
              }
            ],
            defaultNextCid: 5
          },
          5: {
            '@type': 'TimeRouterModule',
            serviceNumber: '4778403123',
            id: 5,
            type: 'TimeRouter',
            name: 'Opening Hours',
            posX: 549,
            posY: 11,
            customizable: true,
            timeRouterEntries: [
              {
                dayOfWeek: 3,
                startHour: 0,
                startMin: 0,
                duration: 1320,
                nextCid: 43
              },
              {
                dayOfWeek: 6,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 7,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 1,
                startHour: 8,
                startMin: 0,
                duration: 480,
                nextCid: 43
              },
              {
                dayOfWeek: 5,
                startHour: 8,
                startMin: 0,
                duration: 480,
                nextCid: 43
              }
            ],
            legalNextComponents: [
              {
                cid: 0,
                displayName: null
              },
              {
                cid: 43,
                displayName: null
              }
            ],
            defaultNextCid: 20
          },
          6: {
            '@type': 'PromptModule',
            serviceNumber: '4778403123',
            id: 6,
            type: 'Prompt',
            name: 'Switchboard closed message',
            posX: 139,
            posY: 562,
            customizable: true,
            messageName: '../officeclosed.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          20: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778403123',
            id: 20,
            type: 'CustomSwitch',
            name: 'Outside OpeningHours Profile',
            posX: 354,
            posY: 337,
            customizable: true,
            legalNextComponents: [
              {
                cid: 6,
                displayName: 'Closed Announcement'
              },
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: null
              },
              {
                cid: 24,
                displayName: 'Phone number'
              },
              {
                cid: 25,
                displayName: 'Company Extension or Group'
              },
              {
                cid: 31,
                displayName: null
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 6,
            stateCid: 40
          },
          22: {
            '@type': 'TerminationModule',
            serviceNumber: '4778403123',
            id: 22,
            type: 'Termination',
            name: 'Autoattendant',
            posX: 658,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4770238871001',
            breleaseCall: false
          },
          23: {
            '@type': 'TerminationModule',
            serviceNumber: '4778403123',
            id: 23,
            type: 'Termination',
            name: 'Member Voicemail',
            posX: 762,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: '4791902493',
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791509001',
            breleaseCall: false
          },
          24: {
            '@type': 'TerminationModule',
            serviceNumber: '4778403123',
            id: 24,
            type: 'Termination',
            name: 'Colleague Number',
            posX: 887,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: 'null',
            breleaseCall: false
          },
          25: {
            '@type': 'TerminationModule',
            serviceNumber: '4778403123',
            id: 25,
            type: 'Termination',
            name: 'CompanyExt',
            posX: 318,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791902493',
            breleaseCall: false
          },
          31: {
            '@type': 'TerminationModule',
            serviceNumber: '4778403123',
            id: 31,
            type: 'Termination',
            name: 'Queue',
            posX: 57,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4770238871',
            breleaseCall: false
          },
          40: {
            '@type': 'PromptModule',
            serviceNumber: '4778403123',
            id: 40,
            type: 'Prompt',
            name: 'CompanyVMMessage',
            posX: 385,
            posY: 465,
            customizable: true,
            messageName: '../Bedriftens_VMS.wav',
            nextCid: 41,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          41: {
            '@type': 'Component',
            serviceNumber: '4778403123',
            id: 41,
            type: 'Record',
            name: 'VMRecord',
            posX: 417,
            posY: 611,
            customizable: false
          },
          42: {
            '@type': 'SendMessageModule',
            serviceNumber: '4778403123',
            id: 42,
            type: 'SendMessage',
            name: 'SendEmail',
            posX: 521,
            posY: 607,
            customizable: true,
            protocol: 1,
            delay: 30,
            frequency: 300,
            toAddressExpression: 'priya@@gintel.com',
            fromFullNameExpression: 'Talkmore Sentralbord',
            fromAddressExpression: 'ikke-svar@@talkmore.no',
            subjectExpression: 'Bedriftens talepostkasse fra Talkmore, ny melding fra +@a',
            contentExpression:
              'Du har en melding fra +@a som ringte nummer @B, vennligst se vedlegg.@N@NMeldingen ble mottatt: @D @T@N@NDette er en automatisk generert melding, det er ikke mulig å svare på e-posten.@N@NFor hjelp og tilbakemelding, kontakt kundeservice: https://bedrift.talkmore.no/kundeservice.@N@NHilsen Talkmore.',
            attachementPathExpression: '/mnt/rec_share/@a_@B_@d@t.wav',
            daysBeforeExpire: 1,
            nextCid: null,
            errorCid: null
          },
          43: {
            '@type': 'Component',
            serviceNumber: '4778403123',
            id: 43,
            type: 'Screen',
            name: 'Screen',
            posX: 913,
            posY: 200,
            customizable: false
          },
          44: {
            '@type': 'TerminationModule',
            serviceNumber: '4778403123',
            id: 44,
            type: 'Termination',
            name: 'Continue',
            posX: 1083,
            posY: 197,
            customizable: false,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 1,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '@e',
            breleaseCall: false
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'Screening',
        number: '4778403123001',
        initComponent: 0,
        posX: 40,
        posY: 277,
        installDate: 1601976325000,
        pattern: 9,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1601976325000,
        componentMap: {
          0: {
            '@type': 'CustomMapperModule',
            serviceNumber: '4778403123001',
            id: 0,
            type: 'CustomMapper',
            name: 'Black/Whitelist',
            posX: 260,
            posY: 269,
            customizable: true,
            mapType: 1,
            matchExact: false,
            resultIsCid: false,
            matchNextCid: 1,
            noMatchNextCid: 6,
            errorNextCid: 6,
            showKey: null,
            showValue: null,
            showKind: null,
            showStatId: null,
            showDate: null,
            showLogin: null,
            customerMapperEntries: []
          },
          1: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778403123001',
            id: 1,
            type: 'CustomSwitch',
            name: 'In List Profile',
            posX: 431,
            posY: 153,
            customizable: true,
            legalNextComponents: [
              {
                cid: 2,
                displayName: null
              },
              {
                cid: 3,
                displayName: null
              },
              {
                cid: 4,
                displayName: null
              },
              {
                cid: 5,
                displayName: null
              }
            ],
            defaultNextCid: null,
            stateCid: null
          },
          2: {
            '@type': 'PromptModule',
            serviceNumber: '4778403123001',
            id: 2,
            type: 'Prompt',
            name: 'In list Message',
            posX: 634,
            posY: 53,
            customizable: true,
            messageName: '',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          3: {
            '@type': 'TerminationModule',
            serviceNumber: '4778403123001',
            id: 3,
            type: 'Termination',
            name: 'In list CompanyExt',
            posX: 694,
            posY: 110,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          4: {
            '@type': 'TerminationModule',
            serviceNumber: '4778403123001',
            id: 4,
            type: 'Termination',
            name: 'In list AutoAttendant',
            posX: 691,
            posY: 198,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          5: {
            '@type': 'TerminationModule',
            serviceNumber: '4778403123001',
            id: 5,
            type: 'Termination',
            name: 'In list AnswerGroup',
            posX: 607,
            posY: 260,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          6: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778403123001',
            id: 6,
            type: 'CustomSwitch',
            name: 'Not in list profile',
            posX: 449,
            posY: 471,
            customizable: true,
            legalNextComponents: [
              {
                cid: 7,
                displayName: null
              },
              {
                cid: 8,
                displayName: null
              },
              {
                cid: 9,
                displayName: null
              },
              {
                cid: 10,
                displayName: null
              }
            ],
            defaultNextCid: null,
            stateCid: null
          },
          7: {
            '@type': 'PromptModule',
            serviceNumber: '4778403123001',
            id: 7,
            type: 'Prompt',
            name: 'Not in list Message',
            posX: 650,
            posY: 359,
            customizable: true,
            messageName: '',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          8: {
            '@type': 'TerminationModule',
            serviceNumber: '4778403123001',
            id: 8,
            type: 'Termination',
            name: 'Not in list CompanyExt',
            posX: 716,
            posY: 437,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          9: {
            '@type': 'TerminationModule',
            serviceNumber: '4778403123001',
            id: 9,
            type: 'Termination',
            name: 'Not in list AnswerGroup',
            posX: 642,
            posY: 628,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          10: {
            '@type': 'TerminationModule',
            serviceNumber: '4778403123001',
            id: 10,
            type: 'Termination',
            name: 'Not in list AutoAttendant',
            posX: 710,
            posY: 546,
            customizable: true,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'AA Svargrupper IMG 4778974931',
        number: '4778974931',
        initComponent: 4,
        posX: 10,
        posY: 19,
        installDate: 1573728020000,
        pattern: 2,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1573727972000,
        componentMap: {
          0: {
            '@type': 'QueueModule',
            serviceNumber: '4778974931',
            id: 0,
            type: 'Queue',
            name: 'AA Svargrupper IMG 4778974931',
            posX: 884,
            posY: 19,
            customizable: true,
            messageSequences: [
              {
                seqNo: 1,
                messageName: '../silence.wav',
                description: 'dummy',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              },
              {
                seqNo: 2,
                messageName: '../welcome.wav',
                description: 'welcome',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              },
              {
                seqNo: 3,
                messageName: '../ringingtone.wav',
                description: 'music',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              },
              {
                seqNo: 4,
                messageName: '../periodical.wav',
                description: 'periodical',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              }
            ],
            queueFullCid: 26,
            kickoutTimeCid: 26,
            kickoutNoAgentsCid: 26,
            ivrErrorCid: null,
            maxPositions: 0,
            maxTime: 30,
            checkFrequency: 30,
            kickoutTime: 30,
            kickoutNoAgents: 120,
            displayUpdateFrequency: 30,
            bnoAnaOrig: 210,
            noReplyTime: 15,
            chargingString: '511',
            noConnectFlags: 4095,
            agentDisplayMode: 5,
            disconnectACid: null,
            disconnectBCid: null,
            disconnectNotAnsweredCid: null,
            pauseCid: 36,
            pauseTime: null,
            pauseRepeat: true,
            svcDegreeTime: 60,
            language: null,
            maxConnectTime: null,
            agentWarningTime: null,
            agentIntroMessage: null,
            callerIntroMessage: false,
            transferDisplayMode: 2,
            dtmfCharacter: null,
            dtmfInConversationCid: null,
            dtmfInQueueCid: null,
            transferFailedCid: null,
            freeAgentOnTransfer: true,
            recordCall: false,
            recordCallFilename: null,
            agentSearchBackground: true,
            parallel: 0,
            huntType: 2,
            tempUnavailableTimeout: null,
            huntIterations: 1,
            smsWhenLoggOff: null,
            maxMissedCounter: null,
            huntActionMissed: 0,
            transferMessage: null,
            bctDisplayMode: -1,
            huntFailedCid: null,
            rejectCid: 26,
            rejectType: -1,
            genericNumberDisplayExpression: null,
            bctDisplayExpression: null,
            transferDisplayExpression: null,
            alarmTime: 0,
            alarmLength: 0,
            alarmRejectEnabled: false,
            alarmKickoutEnabled: false,
            alarmLastAgentEnabled: false,
            alarmFirstAgentEnabled: false,
            alarmRecipients: '',
            cnumber: '22399126'
          },
          3: {
            '@type': 'QueueModule',
            serviceNumber: '4778974931',
            id: 3,
            type: 'Queue',
            name: 'Holdqueue',
            posX: 825,
            posY: 320,
            customizable: true,
            messageSequences: [
              {
                seqNo: 1,
                messageName: '../ringingtone.wav',
                description: 'music',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 1
              }
            ],
            queueFullCid: 0,
            kickoutTimeCid: 0,
            kickoutNoAgentsCid: null,
            ivrErrorCid: null,
            maxPositions: 10,
            maxTime: 300,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 9999,
            displayUpdateFrequency: 30,
            bnoAnaOrig: 210,
            noReplyTime: 20,
            chargingString: '511',
            noConnectFlags: 4095,
            agentDisplayMode: 5,
            disconnectACid: null,
            disconnectBCid: null,
            disconnectNotAnsweredCid: null,
            pauseCid: null,
            pauseTime: null,
            pauseRepeat: false,
            svcDegreeTime: 60,
            language: null,
            maxConnectTime: null,
            agentWarningTime: null,
            agentIntroMessage: null,
            callerIntroMessage: false,
            transferDisplayMode: 2,
            dtmfCharacter: null,
            dtmfInConversationCid: null,
            dtmfInQueueCid: null,
            transferFailedCid: null,
            freeAgentOnTransfer: true,
            recordCall: false,
            recordCallFilename: null,
            agentSearchBackground: false,
            parallel: 2,
            huntType: 0,
            tempUnavailableTimeout: 30,
            huntIterations: 1,
            smsWhenLoggOff: null,
            maxMissedCounter: null,
            huntActionMissed: 0,
            transferMessage: null,
            bctDisplayMode: -1,
            huntFailedCid: null,
            rejectCid: null,
            rejectType: null,
            genericNumberDisplayExpression: null,
            bctDisplayExpression: null,
            transferDisplayExpression: null,
            alarmTime: 0,
            alarmLength: 0,
            alarmRejectEnabled: false,
            alarmKickoutEnabled: false,
            alarmLastAgentEnabled: false,
            alarmFirstAgentEnabled: false,
            alarmRecipients: '',
            cnumber: '22399126'
          },
          4: {
            '@type': 'CustomDateModule',
            serviceNumber: '4778974931',
            id: 4,
            type: 'CustomDate',
            name: 'Calendar Holidays',
            posX: 353,
            posY: 19,
            customizable: true,
            dateEntries: [],
            legalNextComponents: [
              {
                cid: 20,
                displayName: null
              }
            ],
            defaultNextCid: 5
          },
          5: {
            '@type': 'TimeRouterModule',
            serviceNumber: '4778974931',
            id: 5,
            type: 'TimeRouter',
            name: 'Opening Hours',
            posX: 551,
            posY: 19,
            customizable: true,
            timeRouterEntries: [
              {
                dayOfWeek: 1,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 2,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 3,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 4,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 5,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 6,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 7,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              }
            ],
            legalNextComponents: [
              {
                cid: 22,
                displayName: null
              },
              {
                cid: 35,
                displayName: null
              }
            ],
            defaultNextCid: 20
          },
          6: {
            '@type': 'PromptModule',
            serviceNumber: '4778974931',
            id: 6,
            type: 'Prompt',
            name: 'Switchboard closed message',
            posX: 68,
            posY: 607,
            customizable: true,
            messageName: '../officeclosed.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          20: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974931',
            id: 20,
            type: 'CustomSwitch',
            name: 'Outside OpeningHours Profile',
            posX: 381,
            posY: 228,
            customizable: true,
            legalNextComponents: [
              {
                cid: 6,
                displayName: 'Closed Announcement'
              },
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: 'Member Voicemail'
              },
              {
                cid: 24,
                displayName: 'Phone number'
              },
              {
                cid: 25,
                displayName: 'Company Extension or Group'
              },
              {
                cid: 31,
                displayName: null
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 6,
            stateCid: null
          },
          22: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974931',
            id: 22,
            type: 'Termination',
            name: 'Choice',
            posX: 626,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          23: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974931',
            id: 23,
            type: 'Termination',
            name: 'redirect user vmx on no reply',
            posX: 710,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: '4791903248',
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791509001',
            breleaseCall: false
          },
          24: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974931',
            id: 24,
            type: 'Termination',
            name: 'Redirect external vmx number',
            posX: 822,
            posY: 623,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          25: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974931',
            id: 25,
            type: 'Termination',
            name: 'CompanyExt',
            posX: 261,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 1,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4737179231',
            breleaseCall: false
          },
          26: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974931',
            id: 26,
            type: 'CustomSwitch',
            name: 'Overflow Profile',
            posX: 973,
            posY: 343,
            customizable: true,
            legalNextComponents: [
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: 'Member Voicemail'
              },
              {
                cid: 29,
                displayName: 'Closed Announcement'
              },
              {
                cid: 30,
                displayName: 'Phone number'
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 29,
            stateCid: 25
          },
          29: {
            '@type': 'PromptModule',
            serviceNumber: '4778974931',
            id: 29,
            type: 'Prompt',
            name: 'Ubesvart - talemelding',
            posX: 1022,
            posY: 623,
            customizable: true,
            messageName: '../overflow.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          30: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974931',
            id: 30,
            type: 'Termination',
            name: 'Overflow Phonenumber redirect',
            posX: 1124,
            posY: 623,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: 'null',
            breleaseCall: false
          },
          31: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974931',
            id: 31,
            type: 'Termination',
            name: 'Different answergroup',
            posX: 0,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4778974932',
            breleaseCall: false
          },
          32: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974931',
            id: 32,
            type: 'CustomSwitch',
            name: 'Include welcome',
            posX: 693,
            posY: 136,
            customizable: true,
            legalNextComponents: [
              {
                cid: 0,
                displayName: null
              }
            ],
            defaultNextCid: 0,
            stateCid: 33
          },
          33: {
            '@type': 'PromptModule',
            serviceNumber: '4778974931',
            id: 33,
            type: 'Prompt',
            name: 'Welcome message',
            posX: 685,
            posY: 256,
            customizable: true,
            messageName: '../welcome.wav',
            nextCid: 0,
            repeatIndicator: 0,
            errorCid: 0,
            disconnectACid: null,
            language: null,
            early: null
          },
          35: {
            '@type': 'Component',
            serviceNumber: '4778974931',
            id: 35,
            type: 'IntLookup',
            name: 'RedirFromAnotherQueue',
            posX: 670,
            posY: 19,
            customizable: false
          },
          36: {
            '@type': 'Component',
            serviceNumber: '4778974931',
            id: 36,
            type: 'IntLookup',
            name: 'CheckValidANumber',
            posX: 1208,
            posY: 21,
            customizable: false
          },
          37: {
            '@type': 'PromptAndCollectModule',
            serviceNumber: '4778974931',
            id: 37,
            type: 'PromptAndCollect',
            name: 'ChoiceCallBackUser',
            posX: 1202,
            posY: 174,
            customizable: false,
            promptAndCollectEntries: [
              {
                digits: '1',
                nextCid: 38,
                statId: null,
                webType: null
              }
            ],
            nextCid: 0,
            startIndicator: 1,
            repeatIndicator: 0,
            numberOfDigits: 1,
            maxReceiveTime: 60,
            terminateDigit: null,
            firstDigitTime: 10,
            nextDigitTime: 10,
            messageName: '../CB_tast1.wav',
            errorCid: 0,
            toFewDigitsCid: 0,
            disconnectACid: null,
            language: null
          },
          38: {
            '@type': 'PromptModule',
            serviceNumber: '4778974931',
            id: 38,
            type: 'Prompt',
            name: 'callback message',
            posX: 1204,
            posY: 287,
            customizable: false,
            messageName: '../Takk_vi_ringer_deg.wav',
            nextCid: 39,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          39: {
            '@type': 'Component',
            serviceNumber: '4778974931',
            id: 39,
            type: 'CallbackQueue',
            name: 'CallbackQueue',
            posX: 1217,
            posY: 431,
            customizable: false
          },
          40: {
            '@type': 'PromptModule',
            serviceNumber: '4778974931',
            id: 40,
            type: 'Prompt',
            name: 'Bedriftens mobilsvar',
            posX: 386,
            posY: 466,
            customizable: true,
            messageName: '../Bedriftens_VMS.wav',
            nextCid: 41,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          41: {
            '@type': 'Component',
            serviceNumber: '4778974931',
            id: 41,
            type: 'Record',
            name: 'record company vmx',
            posX: 415,
            posY: 605,
            customizable: false
          },
          42: {
            '@type': 'SendMessageModule',
            serviceNumber: '4778974931',
            id: 42,
            type: 'SendMessage',
            name: 'Bedriftens mobilsvar',
            posX: 521,
            posY: 607,
            customizable: true,
            protocol: 1,
            delay: 30,
            frequency: 300,
            toAddressExpression: 'harsha.ananda@@gintel.com',
            fromFullNameExpression: 'Dipper Sentralbord',
            fromAddressExpression: 'ikke-svar@@sb.dipper.no',
            subjectExpression: 'Bedriftens talepostkasse fra Dipper, ny melding fra +@a',
            contentExpression:
              'Du har en melding fra +@a, vennligst se vedlegg.@N@NMeldingen ble mottatt: @D @T@N@NDette er en automatisk generert melding, det er ikke mulig å svare på e-posten.@N@NFor hjelp og tilbakemelding, kontakt kundeservice: https://dipper.no/kundeservice.@N@NHilsen Dipper.',
            attachementPathExpression: '/mnt/rec_share/@a_@B_@d@t.wav',
            daysBeforeExpire: 1,
            nextCid: null,
            errorCid: null
          }
        }
      },
      {
        organization: MockData.organization,
        name: '4778974934_NewAG',
        number: '4778974934',
        initComponent: 4,
        posX: 10,
        posY: 19,
        installDate: 1573114596000,
        pattern: 2,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1573114596000,
        componentMap: {
          0: {
            '@type': 'QueueModule',
            serviceNumber: '4778974934',
            id: 0,
            type: 'Queue',
            name: '4778974934_NewAG',
            posX: 884,
            posY: 19,
            customizable: true,
            messageSequences: [
              {
                seqNo: 1,
                messageName: '../silence.wav',
                description: 'dummy',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              },
              {
                seqNo: 2,
                messageName: '../welcome.wav',
                description: 'welcome',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              },
              {
                seqNo: 3,
                messageName: '../ringingtone.wav',
                description: 'music',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 4
              },
              {
                seqNo: 4,
                messageName: '../periodical.wav',
                description: 'periodical',
                duration: 0,
                variablePhrases: null,
                nextSeqNo: 3
              }
            ],
            queueFullCid: 26,
            kickoutTimeCid: 26,
            kickoutNoAgentsCid: 26,
            ivrErrorCid: null,
            maxPositions: 10,
            maxTime: 300,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 120,
            displayUpdateFrequency: 30,
            bnoAnaOrig: 210,
            noReplyTime: 25,
            chargingString: '511',
            noConnectFlags: 4095,
            agentDisplayMode: 5,
            disconnectACid: null,
            disconnectBCid: null,
            disconnectNotAnsweredCid: null,
            pauseCid: null,
            pauseTime: null,
            pauseRepeat: false,
            svcDegreeTime: 60,
            language: null,
            maxConnectTime: null,
            agentWarningTime: null,
            agentIntroMessage: null,
            callerIntroMessage: false,
            transferDisplayMode: null,
            dtmfCharacter: null,
            dtmfInConversationCid: null,
            dtmfInQueueCid: null,
            transferFailedCid: null,
            freeAgentOnTransfer: true,
            recordCall: false,
            recordCallFilename: null,
            agentSearchBackground: true,
            parallel: 0,
            huntType: 2,
            tempUnavailableTimeout: null,
            huntIterations: 1,
            smsWhenLoggOff: null,
            maxMissedCounter: null,
            huntActionMissed: 0,
            transferMessage: null,
            bctDisplayMode: -1,
            huntFailedCid: null,
            rejectCid: 26,
            rejectType: 0,
            genericNumberDisplayExpression: null,
            bctDisplayExpression: null,
            transferDisplayExpression: null,
            alarmTime: 0,
            alarmLength: 0,
            alarmRejectEnabled: false,
            alarmKickoutEnabled: false,
            alarmLastAgentEnabled: false,
            alarmFirstAgentEnabled: false,
            alarmRecipients: '4791902156',
            cnumber: '22399126'
          },
          3: {
            '@type': 'QueueModule',
            serviceNumber: '4778974934',
            id: 3,
            type: 'Queue',
            name: 'Holdqueue',
            posX: 825,
            posY: 320,
            customizable: true,
            messageSequences: [
              {
                seqNo: 1,
                messageName: '../ringingtone.wav',
                description: 'music',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 1
              }
            ],
            queueFullCid: 0,
            kickoutTimeCid: 0,
            kickoutNoAgentsCid: null,
            ivrErrorCid: null,
            maxPositions: 10,
            maxTime: 300,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 9999,
            displayUpdateFrequency: 30,
            bnoAnaOrig: 210,
            noReplyTime: 20,
            chargingString: '511',
            noConnectFlags: 4095,
            agentDisplayMode: 5,
            disconnectACid: null,
            disconnectBCid: null,
            disconnectNotAnsweredCid: null,
            pauseCid: null,
            pauseTime: null,
            pauseRepeat: false,
            svcDegreeTime: 60,
            language: null,
            maxConnectTime: null,
            agentWarningTime: null,
            agentIntroMessage: null,
            callerIntroMessage: false,
            transferDisplayMode: 2,
            dtmfCharacter: null,
            dtmfInConversationCid: null,
            dtmfInQueueCid: null,
            transferFailedCid: null,
            freeAgentOnTransfer: true,
            recordCall: false,
            recordCallFilename: null,
            agentSearchBackground: false,
            parallel: 2,
            huntType: 0,
            tempUnavailableTimeout: 30,
            huntIterations: 1,
            smsWhenLoggOff: null,
            maxMissedCounter: null,
            huntActionMissed: 0,
            transferMessage: null,
            bctDisplayMode: -1,
            huntFailedCid: null,
            rejectCid: null,
            rejectType: null,
            genericNumberDisplayExpression: null,
            bctDisplayExpression: null,
            transferDisplayExpression: null,
            alarmTime: 0,
            alarmLength: 0,
            alarmRejectEnabled: false,
            alarmKickoutEnabled: false,
            alarmLastAgentEnabled: false,
            alarmFirstAgentEnabled: false,
            alarmRecipients: '',
            cnumber: '22399126'
          },
          4: {
            '@type': 'CustomDateModule',
            serviceNumber: '4778974934',
            id: 4,
            type: 'CustomDate',
            name: 'Calendar Holidays',
            posX: 353,
            posY: 19,
            customizable: true,
            dateEntries: [],
            legalNextComponents: [
              {
                cid: 20,
                displayName: null
              }
            ],
            defaultNextCid: 5
          },
          5: {
            '@type': 'TimeRouterModule',
            serviceNumber: '4778974934',
            id: 5,
            type: 'TimeRouter',
            name: 'Opening Hours',
            posX: 551,
            posY: 19,
            customizable: true,
            timeRouterEntries: [
              {
                dayOfWeek: 1,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 2,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 3,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 4,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 5,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 6,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 7,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              }
            ],
            legalNextComponents: [
              {
                cid: 22,
                displayName: null
              },
              {
                cid: 35,
                displayName: null
              }
            ],
            defaultNextCid: 20
          },
          6: {
            '@type': 'PromptModule',
            serviceNumber: '4778974934',
            id: 6,
            type: 'Prompt',
            name: 'Switchboard closed message',
            posX: 68,
            posY: 607,
            customizable: true,
            messageName: '../officeclosed.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          20: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974934',
            id: 20,
            type: 'CustomSwitch',
            name: 'Outside OpeningHours Profile',
            posX: 381,
            posY: 228,
            customizable: true,
            legalNextComponents: [
              {
                cid: 6,
                displayName: 'Closed Announcement'
              },
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: 'Member Voicemail'
              },
              {
                cid: 24,
                displayName: 'Phone number'
              },
              {
                cid: 25,
                displayName: 'Company Extension or Group'
              },
              {
                cid: 31,
                displayName: null
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 6,
            stateCid: null
          },
          22: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974934',
            id: 22,
            type: 'Termination',
            name: 'Choice',
            posX: 626,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4722535028001',
            breleaseCall: false
          },
          23: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974934',
            id: 23,
            type: 'Termination',
            name: 'redirect user vmx on no reply',
            posX: 710,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: '4791903248',
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791509001',
            breleaseCall: false
          },
          24: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974934',
            id: 24,
            type: 'Termination',
            name: 'Redirect external vmx number',
            posX: 822,
            posY: 623,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          25: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974934',
            id: 25,
            type: 'Termination',
            name: 'CompanyExt',
            posX: 261,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 1,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791903248',
            breleaseCall: false
          },
          26: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974934',
            id: 26,
            type: 'CustomSwitch',
            name: 'Overflow Profile',
            posX: 973,
            posY: 343,
            customizable: true,
            legalNextComponents: [
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: 'Member Voicemail'
              },
              {
                cid: 29,
                displayName: 'Closed Announcement'
              },
              {
                cid: 30,
                displayName: 'Phone number'
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 29,
            stateCid: 29
          },
          29: {
            '@type': 'PromptModule',
            serviceNumber: '4778974934',
            id: 29,
            type: 'Prompt',
            name: 'Ubesvart - talemelding',
            posX: 1022,
            posY: 623,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/file1MG.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          30: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974934',
            id: 30,
            type: 'Termination',
            name: 'Overflow Phonenumber redirect',
            posX: 1124,
            posY: 623,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: 'null',
            breleaseCall: false
          },
          31: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974934',
            id: 31,
            type: 'Termination',
            name: 'Different answergroup',
            posX: 0,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4770238717',
            breleaseCall: false
          },
          32: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974934',
            id: 32,
            type: 'CustomSwitch',
            name: 'Include welcome',
            posX: 693,
            posY: 136,
            customizable: true,
            legalNextComponents: [
              {
                cid: 0,
                displayName: null
              }
            ],
            defaultNextCid: 0,
            stateCid: 33
          },
          33: {
            '@type': 'PromptModule',
            serviceNumber: '4778974934',
            id: 33,
            type: 'Prompt',
            name: 'Welcome message',
            posX: 685,
            posY: 256,
            customizable: true,
            messageName: '../welcome.wav',
            nextCid: 0,
            repeatIndicator: 0,
            errorCid: 0,
            disconnectACid: null,
            language: null,
            early: null
          },
          35: {
            '@type': 'Component',
            serviceNumber: '4778974934',
            id: 35,
            type: 'IntLookup',
            name: 'RedirFromAnotherQueue',
            posX: 670,
            posY: 19,
            customizable: false
          },
          36: {
            '@type': 'Component',
            serviceNumber: '4778974934',
            id: 36,
            type: 'IntLookup',
            name: 'CheckValidANumber',
            posX: 1208,
            posY: 21,
            customizable: false
          },
          37: {
            '@type': 'PromptAndCollectModule',
            serviceNumber: '4778974934',
            id: 37,
            type: 'PromptAndCollect',
            name: 'ChoiceCallBackUser',
            posX: 1202,
            posY: 174,
            customizable: false,
            promptAndCollectEntries: [
              {
                digits: '1',
                nextCid: 38,
                statId: null,
                webType: null
              }
            ],
            nextCid: 0,
            startIndicator: 1,
            repeatIndicator: 0,
            numberOfDigits: 1,
            maxReceiveTime: 60,
            terminateDigit: null,
            firstDigitTime: 10,
            nextDigitTime: 10,
            messageName: '../CB_tast1.wav',
            errorCid: 0,
            toFewDigitsCid: 0,
            disconnectACid: null,
            language: null
          },
          38: {
            '@type': 'PromptModule',
            serviceNumber: '4778974934',
            id: 38,
            type: 'Prompt',
            name: 'callback message',
            posX: 1204,
            posY: 287,
            customizable: false,
            messageName: '../Takk_vi_ringer_deg.wav',
            nextCid: 39,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          39: {
            '@type': 'Component',
            serviceNumber: '4778974934',
            id: 39,
            type: 'CallbackQueue',
            name: 'CallbackQueue',
            posX: 1217,
            posY: 431,
            customizable: false
          },
          40: {
            '@type': 'PromptModule',
            serviceNumber: '4778974934',
            id: 40,
            type: 'Prompt',
            name: 'Bedriftens mobilsvar',
            posX: 386,
            posY: 466,
            customizable: true,
            messageName: '../Bedriftens_VMS.wav',
            nextCid: 41,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          41: {
            '@type': 'Component',
            serviceNumber: '4778974934',
            id: 41,
            type: 'Record',
            name: 'record company vmx',
            posX: 415,
            posY: 605,
            customizable: false
          },
          42: {
            '@type': 'SendMessageModule',
            serviceNumber: '4778974934',
            id: 42,
            type: 'SendMessage',
            name: 'Bedriftens mobilsvar',
            posX: 521,
            posY: 607,
            customizable: true,
            protocol: 1,
            delay: 30,
            frequency: 300,
            toAddressExpression: '',
            fromFullNameExpression: 'Dipper Sentralbord',
            fromAddressExpression: 'ikke-svar@@sb.dipper.no',
            subjectExpression: 'Bedriftens talepostkasse fra Dipper, ny melding fra +@a',
            contentExpression:
              'Du har en melding fra +@a, vennligst se vedlegg.@N@NMeldingen ble mottatt: @D @T@N@NDette er en automatisk generert melding, det er ikke mulig å svare på e-posten.@N@NFor hjelp og tilbakemelding, kontakt kundeservice: https://dipper.no/kundeservice.@N@NHilsen Dipper.',
            attachementPathExpression: '/mnt/rec_share/@a_@B_@d@t.wav',
            daysBeforeExpire: 1,
            nextCid: null,
            errorCid: null
          },
          43: {
            '@type': 'SendSmsModule',
            serviceNumber: '4778974934',
            id: 43,
            type: 'SendSMS',
            name: '43 SendSMS',
            posX: 1345,
            posY: 406,
            customizable: true,
            source: '',
            displaySource: '',
            destination: '@A',
            message: '',
            nextCid: null,
            errorCid: null
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'Å svargruppe_04158',
        number: '4778974937',
        initComponent: 4,
        posX: 10,
        posY: 19,
        installDate: 1582103628000,
        pattern: 2,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1582103628000,
        componentMap: {
          0: {
            '@type': 'QueueModule',
            serviceNumber: '4778974937',
            id: 0,
            type: 'Queue',
            name: 'Å svargruppe_04158',
            posX: 884,
            posY: 19,
            customizable: true,
            messageSequences: [
              {
                seqNo: 1,
                messageName: '../silence.wav',
                description: 'dummy',
                duration: 0,
                variablePhrases: null,
                nextSeqNo: 3
              },
              {
                seqNo: 2,
                messageName: '../welcome.wav',
                description: 'welcome',
                duration: 0,
                variablePhrases: null,
                nextSeqNo: 3
              },
              {
                seqNo: 3,
                messageName: '../ringingtone.wav',
                description: 'music',
                duration: 0,
                variablePhrases: null,
                nextSeqNo: 4
              },
              {
                seqNo: 4,
                messageName: '../periodical.wav',
                description: 'periodical',
                duration: 0,
                variablePhrases: null,
                nextSeqNo: 3
              }
            ],
            queueFullCid: 26,
            kickoutTimeCid: 26,
            kickoutNoAgentsCid: 26,
            ivrErrorCid: null,
            maxPositions: 10,
            maxTime: 300,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 120,
            displayUpdateFrequency: 30,
            bnoAnaOrig: 210,
            noReplyTime: 25,
            chargingString: '511',
            noConnectFlags: 4095,
            agentDisplayMode: 5,
            disconnectACid: null,
            disconnectBCid: null,
            disconnectNotAnsweredCid: null,
            pauseCid: 36,
            pauseTime: 40,
            pauseRepeat: true,
            svcDegreeTime: 60,
            language: null,
            maxConnectTime: null,
            agentWarningTime: null,
            agentIntroMessage: null,
            callerIntroMessage: false,
            transferDisplayMode: null,
            dtmfCharacter: null,
            dtmfInConversationCid: null,
            dtmfInQueueCid: null,
            transferFailedCid: null,
            freeAgentOnTransfer: true,
            recordCall: false,
            recordCallFilename: null,
            agentSearchBackground: true,
            parallel: 0,
            huntType: 2,
            tempUnavailableTimeout: null,
            huntIterations: 1,
            smsWhenLoggOff: null,
            maxMissedCounter: null,
            huntActionMissed: 0,
            transferMessage: null,
            bctDisplayMode: -1,
            huntFailedCid: null,
            rejectCid: 26,
            rejectType: 0,
            genericNumberDisplayExpression: null,
            bctDisplayExpression: null,
            transferDisplayExpression: null,
            alarmTime: 0,
            alarmLength: 0,
            alarmRejectEnabled: false,
            alarmKickoutEnabled: false,
            alarmLastAgentEnabled: false,
            alarmFirstAgentEnabled: false,
            alarmRecipients: '',
            cnumber: '22399126'
          },
          3: {
            '@type': 'QueueModule',
            serviceNumber: '4778974937',
            id: 3,
            type: 'Queue',
            name: 'Holdqueue',
            posX: 825,
            posY: 320,
            customizable: true,
            messageSequences: [
              {
                seqNo: 1,
                messageName: '../ringingtone.wav',
                description: 'music',
                duration: 0,
                variablePhrases: null,
                nextSeqNo: 1
              }
            ],
            queueFullCid: 0,
            kickoutTimeCid: 0,
            kickoutNoAgentsCid: null,
            ivrErrorCid: null,
            maxPositions: 10,
            maxTime: 300,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 9999,
            displayUpdateFrequency: 30,
            bnoAnaOrig: 210,
            noReplyTime: 20,
            chargingString: '511',
            noConnectFlags: 4095,
            agentDisplayMode: 5,
            disconnectACid: null,
            disconnectBCid: null,
            disconnectNotAnsweredCid: null,
            pauseCid: null,
            pauseTime: null,
            pauseRepeat: false,
            svcDegreeTime: 60,
            language: null,
            maxConnectTime: null,
            agentWarningTime: null,
            agentIntroMessage: null,
            callerIntroMessage: false,
            transferDisplayMode: 2,
            dtmfCharacter: null,
            dtmfInConversationCid: null,
            dtmfInQueueCid: null,
            transferFailedCid: null,
            freeAgentOnTransfer: true,
            recordCall: false,
            recordCallFilename: null,
            agentSearchBackground: false,
            parallel: 2,
            huntType: 0,
            tempUnavailableTimeout: 30,
            huntIterations: 1,
            smsWhenLoggOff: '',
            maxMissedCounter: null,
            huntActionMissed: 0,
            transferMessage: null,
            bctDisplayMode: -1,
            huntFailedCid: null,
            rejectCid: null,
            rejectType: null,
            genericNumberDisplayExpression: null,
            bctDisplayExpression: null,
            transferDisplayExpression: null,
            alarmTime: 0,
            alarmLength: 0,
            alarmRejectEnabled: false,
            alarmKickoutEnabled: false,
            alarmLastAgentEnabled: false,
            alarmFirstAgentEnabled: false,
            alarmRecipients: '',
            cnumber: '22399126'
          },
          4: {
            '@type': 'CustomDateModule',
            serviceNumber: '4778974937',
            id: 4,
            type: 'CustomDate',
            name: 'Calendar Holidays',
            posX: 353,
            posY: 19,
            customizable: true,
            dateEntries: [],
            legalNextComponents: [
              {
                cid: 20,
                displayName: null
              }
            ],
            defaultNextCid: 5
          },
          5: {
            '@type': 'TimeRouterModule',
            serviceNumber: '4778974937',
            id: 5,
            type: 'TimeRouter',
            name: 'Opening Hours',
            posX: 551,
            posY: 19,
            customizable: true,
            timeRouterEntries: [
              {
                dayOfWeek: 1,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 2,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 3,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 4,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 5,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 6,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 7,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              }
            ],
            legalNextComponents: [
              {
                cid: 22,
                displayName: null
              },
              {
                cid: 35,
                displayName: null
              }
            ],
            defaultNextCid: 20
          },
          6: {
            '@type': 'PromptModule',
            serviceNumber: '4778974937',
            id: 6,
            type: 'Prompt',
            name: 'Switchboard closed message',
            posX: 68,
            posY: 607,
            customizable: true,
            messageName: '../officeclosed.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          20: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974937',
            id: 20,
            type: 'CustomSwitch',
            name: 'Outside OpeningHours Profile',
            posX: 381,
            posY: 228,
            customizable: true,
            legalNextComponents: [
              {
                cid: 6,
                displayName: 'Closed Announcement'
              },
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: 'Member Voicemail'
              },
              {
                cid: 24,
                displayName: 'Phone number'
              },
              {
                cid: 25,
                displayName: 'Company Extension or Group'
              },
              {
                cid: 31,
                displayName: null
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 6,
            stateCid: null
          },
          22: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974937',
            id: 22,
            type: 'Termination',
            name: 'Choice',
            posX: 626,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          23: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974937',
            id: 23,
            type: 'Termination',
            name: 'redirect user vmx on no reply',
            posX: 710,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791509001',
            breleaseCall: false
          },
          24: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974937',
            id: 24,
            type: 'Termination',
            name: 'Redirect external vmx number',
            posX: 822,
            posY: 623,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          25: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974937',
            id: 25,
            type: 'Termination',
            name: 'CompanyExt',
            posX: 261,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 1,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          26: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974937',
            id: 26,
            type: 'CustomSwitch',
            name: 'Overflow Profile',
            posX: 973,
            posY: 343,
            customizable: true,
            legalNextComponents: [
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: 'Member Voicemail'
              },
              {
                cid: 29,
                displayName: 'Closed Announcement'
              },
              {
                cid: 30,
                displayName: 'Phone number'
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 29,
            stateCid: 29
          },
          29: {
            '@type': 'PromptModule',
            serviceNumber: '4778974937',
            id: 29,
            type: 'Prompt',
            name: 'Ubesvart - talemelding',
            posX: 1022,
            posY: 623,
            customizable: true,
            messageName: '../overflow.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          30: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974937',
            id: 30,
            type: 'Termination',
            name: 'Overflow Phonenumber redirect',
            posX: 1124,
            posY: 623,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          31: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974937',
            id: 31,
            type: 'Termination',
            name: 'Different answergroup',
            posX: 0,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          32: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974937',
            id: 32,
            type: 'CustomSwitch',
            name: 'Include welcome',
            posX: 693,
            posY: 136,
            customizable: true,
            legalNextComponents: [
              {
                cid: 0,
                displayName: null
              }
            ],
            defaultNextCid: 0,
            stateCid: 33
          },
          33: {
            '@type': 'PromptModule',
            serviceNumber: '4778974937',
            id: 33,
            type: 'Prompt',
            name: 'Welcome message',
            posX: 685,
            posY: 256,
            customizable: true,
            messageName: '../welcome.wav',
            nextCid: 0,
            repeatIndicator: 0,
            errorCid: 0,
            disconnectACid: null,
            language: null,
            early: null
          },
          35: {
            '@type': 'Component',
            serviceNumber: '4778974937',
            id: 35,
            type: 'IntLookup',
            name: 'RedirFromAnotherQueue',
            posX: 670,
            posY: 19,
            customizable: false
          },
          36: {
            '@type': 'Component',
            serviceNumber: '4778974937',
            id: 36,
            type: 'IntLookup',
            name: 'CheckValidANumber',
            posX: 1208,
            posY: 21,
            customizable: false
          },
          37: {
            '@type': 'PromptAndCollectModule',
            serviceNumber: '4778974937',
            id: 37,
            type: 'PromptAndCollect',
            name: 'ChoiceCallBackUser',
            posX: 1202,
            posY: 174,
            customizable: false,
            promptAndCollectEntries: [
              {
                digits: '1',
                nextCid: 38,
                statId: null,
                webType: null
              }
            ],
            nextCid: 0,
            startIndicator: 1,
            repeatIndicator: 0,
            numberOfDigits: 1,
            maxReceiveTime: 60,
            terminateDigit: null,
            firstDigitTime: 10,
            nextDigitTime: 10,
            messageName: '../CB_tast1.wav',
            errorCid: 0,
            toFewDigitsCid: 0,
            disconnectACid: null,
            language: null
          },
          38: {
            '@type': 'PromptModule',
            serviceNumber: '4778974937',
            id: 38,
            type: 'Prompt',
            name: 'callback message',
            posX: 1204,
            posY: 287,
            customizable: false,
            messageName: '../Takk_vi_ringer_deg.wav',
            nextCid: 39,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          39: {
            '@type': 'Component',
            serviceNumber: '4778974937',
            id: 39,
            type: 'CallbackQueue',
            name: 'CallbackQueue',
            posX: 1217,
            posY: 431,
            customizable: false
          },
          40: {
            '@type': 'PromptModule',
            serviceNumber: '4778974937',
            id: 40,
            type: 'Prompt',
            name: 'Bedriftens mobilsvar',
            posX: 386,
            posY: 466,
            customizable: true,
            messageName: '../Bedriftens_VMS.wav',
            nextCid: 41,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          41: {
            '@type': 'Component',
            serviceNumber: '4778974937',
            id: 41,
            type: 'Record',
            name: 'record company vmx',
            posX: 415,
            posY: 605,
            customizable: false
          },
          42: {
            '@type': 'SendMessageModule',
            serviceNumber: '4778974937',
            id: 42,
            type: 'SendMessage',
            name: 'Bedriftens mobilsvar',
            posX: 521,
            posY: 607,
            customizable: true,
            protocol: 1,
            delay: 30,
            frequency: 300,
            toAddressExpression: '',
            fromFullNameExpression: 'Dipper Sentralbord',
            fromAddressExpression: 'ikke-svar@@sb.dipper.no',
            subjectExpression: 'Bedriftens talepostkasse fra Dipper, ny melding fra +@a',
            contentExpression:
              'Du har en melding fra +@a, vennligst se vedlegg.@N@NMeldingen ble mottatt: @D @T@N@NDette er en automatisk generert melding, det er ikke mulig å svare på e-posten.@N@NFor hjelp og tilbakemelding, kontakt kundeservice: https://dipper.no/kundeservice.@N@NHilsen Dipper.',
            attachementPathExpression: '/mnt/rec_share/@a_@B_@d@t.wav',
            daysBeforeExpire: 1,
            nextCid: null,
            errorCid: null
          },
          43: {
            '@type': 'SendSmsModule',
            serviceNumber: '4778974937',
            id: 43,
            type: 'SendSMS',
            name: '43 SendSMS',
            posX: 1345,
            posY: 406,
            customizable: true,
            source: '',
            displaySource: '',
            destination: '@A',
            message: '',
            nextCid: null,
            errorCid: null
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'Svargruppe_91906218',
        number: '4778974938',
        initComponent: 4,
        posX: 10,
        posY: 19,
        installDate: 1585810417000,
        pattern: 2,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1585810417000,
        componentMap: {
          0: {
            '@type': 'QueueModule',
            serviceNumber: '4778974938',
            id: 0,
            type: 'Queue',
            name: 'Svargruppe_91906218',
            posX: 884,
            posY: 19,
            customizable: true,
            messageSequences: [
              {
                seqNo: 1,
                messageName: '../silence.wav',
                description: 'dummy',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              },
              {
                seqNo: 2,
                messageName: '../welcome.wav',
                description: 'welcome',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              },
              {
                seqNo: 3,
                messageName: '../ringingtone.wav',
                description: 'music',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 4
              },
              {
                seqNo: 4,
                messageName: '../periodical.wav',
                description: 'periodical',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 3
              }
            ],
            queueFullCid: 26,
            kickoutTimeCid: 26,
            kickoutNoAgentsCid: 26,
            ivrErrorCid: null,
            maxPositions: 10,
            maxTime: 300,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 120,
            displayUpdateFrequency: 30,
            bnoAnaOrig: 210,
            noReplyTime: 30,
            chargingString: '511',
            noConnectFlags: 4095,
            agentDisplayMode: 5,
            disconnectACid: null,
            disconnectBCid: null,
            disconnectNotAnsweredCid: null,
            pauseCid: 36,
            pauseTime: 40,
            pauseRepeat: true,
            svcDegreeTime: 60,
            language: null,
            maxConnectTime: null,
            agentWarningTime: null,
            agentIntroMessage: null,
            callerIntroMessage: false,
            transferDisplayMode: null,
            dtmfCharacter: null,
            dtmfInConversationCid: null,
            dtmfInQueueCid: null,
            transferFailedCid: null,
            freeAgentOnTransfer: true,
            recordCall: false,
            recordCallFilename: null,
            agentSearchBackground: true,
            parallel: 0,
            huntType: 2,
            tempUnavailableTimeout: null,
            huntIterations: 1,
            smsWhenLoggOff: null,
            maxMissedCounter: null,
            huntActionMissed: 0,
            transferMessage: null,
            bctDisplayMode: -1,
            huntFailedCid: null,
            rejectCid: 26,
            rejectType: 0,
            genericNumberDisplayExpression: null,
            bctDisplayExpression: null,
            transferDisplayExpression: null,
            alarmTime: 0,
            alarmLength: 0,
            alarmRejectEnabled: false,
            alarmKickoutEnabled: false,
            alarmLastAgentEnabled: false,
            alarmFirstAgentEnabled: false,
            alarmRecipients: '',
            cnumber: '22399126'
          },
          3: {
            '@type': 'QueueModule',
            serviceNumber: '4778974938',
            id: 3,
            type: 'Queue',
            name: 'Holdqueue',
            posX: 825,
            posY: 320,
            customizable: true,
            messageSequences: [
              {
                seqNo: 1,
                messageName: '../ringingtone.wav',
                description: 'music',
                duration: 0,
                variablePhrases: 0,
                nextSeqNo: 1
              }
            ],
            queueFullCid: 0,
            kickoutTimeCid: 0,
            kickoutNoAgentsCid: null,
            ivrErrorCid: null,
            maxPositions: 10,
            maxTime: 300,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 9999,
            displayUpdateFrequency: 30,
            bnoAnaOrig: 210,
            noReplyTime: 20,
            chargingString: '511',
            noConnectFlags: 4095,
            agentDisplayMode: 5,
            disconnectACid: null,
            disconnectBCid: null,
            disconnectNotAnsweredCid: null,
            pauseCid: null,
            pauseTime: null,
            pauseRepeat: false,
            svcDegreeTime: 60,
            language: null,
            maxConnectTime: null,
            agentWarningTime: null,
            agentIntroMessage: null,
            callerIntroMessage: false,
            transferDisplayMode: 2,
            dtmfCharacter: null,
            dtmfInConversationCid: null,
            dtmfInQueueCid: null,
            transferFailedCid: null,
            freeAgentOnTransfer: true,
            recordCall: false,
            recordCallFilename: null,
            agentSearchBackground: false,
            parallel: 2,
            huntType: 0,
            tempUnavailableTimeout: 30,
            huntIterations: 1,
            smsWhenLoggOff: '',
            maxMissedCounter: null,
            huntActionMissed: 0,
            transferMessage: null,
            bctDisplayMode: -1,
            huntFailedCid: null,
            rejectCid: null,
            rejectType: null,
            genericNumberDisplayExpression: null,
            bctDisplayExpression: null,
            transferDisplayExpression: null,
            alarmTime: 0,
            alarmLength: 0,
            alarmRejectEnabled: false,
            alarmKickoutEnabled: false,
            alarmLastAgentEnabled: false,
            alarmFirstAgentEnabled: false,
            alarmRecipients: '',
            cnumber: '22399126'
          },
          4: {
            '@type': 'CustomDateModule',
            serviceNumber: '4778974938',
            id: 4,
            type: 'CustomDate',
            name: 'Calendar Holidays',
            posX: 353,
            posY: 19,
            customizable: true,
            dateEntries: [],
            legalNextComponents: [
              {
                cid: 20,
                displayName: null
              }
            ],
            defaultNextCid: 5
          },
          5: {
            '@type': 'TimeRouterModule',
            serviceNumber: '4778974938',
            id: 5,
            type: 'TimeRouter',
            name: 'Opening Hours',
            posX: 551,
            posY: 19,
            customizable: true,
            timeRouterEntries: [
              {
                dayOfWeek: 1,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 2,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 3,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 4,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 5,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 6,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 7,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              }
            ],
            legalNextComponents: [
              {
                cid: 22,
                displayName: null
              },
              {
                cid: 35,
                displayName: null
              }
            ],
            defaultNextCid: 20
          },
          6: {
            '@type': 'PromptModule',
            serviceNumber: '4778974938',
            id: 6,
            type: 'Prompt',
            name: 'Switchboard closed message',
            posX: 68,
            posY: 607,
            customizable: true,
            messageName: '../officeclosed.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          20: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974938',
            id: 20,
            type: 'CustomSwitch',
            name: 'Outside OpeningHours Profile',
            posX: 381,
            posY: 228,
            customizable: true,
            legalNextComponents: [
              {
                cid: 6,
                displayName: 'Closed Announcement'
              },
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: 'Member Voicemail'
              },
              {
                cid: 24,
                displayName: 'Phone number'
              },
              {
                cid: 25,
                displayName: 'Company Extension or Group'
              },
              {
                cid: 31,
                displayName: null
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 6,
            stateCid: null
          },
          22: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974938',
            id: 22,
            type: 'Termination',
            name: 'Choice',
            posX: 626,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          23: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974938',
            id: 23,
            type: 'Termination',
            name: 'redirect user vmx on no reply',
            posX: 710,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791509001',
            breleaseCall: false
          },
          24: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974938',
            id: 24,
            type: 'Termination',
            name: 'Redirect external vmx number',
            posX: 822,
            posY: 623,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          25: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974938',
            id: 25,
            type: 'Termination',
            name: 'CompanyExt',
            posX: 261,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 1,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791905129',
            breleaseCall: false
          },
          26: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974938',
            id: 26,
            type: 'CustomSwitch',
            name: 'Overflow Profile',
            posX: 973,
            posY: 343,
            customizable: true,
            legalNextComponents: [
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: 'Member Voicemail'
              },
              {
                cid: 29,
                displayName: 'Closed Announcement'
              },
              {
                cid: 30,
                displayName: 'Phone number'
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 29,
            stateCid: 31
          },
          29: {
            '@type': 'PromptModule',
            serviceNumber: '4778974938',
            id: 29,
            type: 'Prompt',
            name: 'Ubesvart - talemelding',
            posX: 1022,
            posY: 623,
            customizable: true,
            messageName: '../overflow.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          30: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974938',
            id: 30,
            type: 'Termination',
            name: 'Overflow Phonenumber redirect',
            posX: 1124,
            posY: 623,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: 'null',
            breleaseCall: false
          },
          31: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974938',
            id: 31,
            type: 'Termination',
            name: 'Different answergroup',
            posX: 0,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4778974973',
            breleaseCall: false
          },
          32: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974938',
            id: 32,
            type: 'CustomSwitch',
            name: 'Include welcome',
            posX: 693,
            posY: 136,
            customizable: true,
            legalNextComponents: [
              {
                cid: 0,
                displayName: null
              }
            ],
            defaultNextCid: 0,
            stateCid: 33
          },
          33: {
            '@type': 'PromptModule',
            serviceNumber: '4778974938',
            id: 33,
            type: 'Prompt',
            name: 'Welcome message',
            posX: 685,
            posY: 256,
            customizable: true,
            messageName: '../welcome.wav',
            nextCid: 0,
            repeatIndicator: 0,
            errorCid: 0,
            disconnectACid: null,
            language: null,
            early: null
          },
          35: {
            '@type': 'Component',
            serviceNumber: '4778974938',
            id: 35,
            type: 'IntLookup',
            name: 'RedirFromAnotherQueue',
            posX: 670,
            posY: 19,
            customizable: false
          },
          36: {
            '@type': 'Component',
            serviceNumber: '4778974938',
            id: 36,
            type: 'IntLookup',
            name: 'CheckValidANumber',
            posX: 1208,
            posY: 21,
            customizable: false
          },
          37: {
            '@type': 'PromptAndCollectModule',
            serviceNumber: '4778974938',
            id: 37,
            type: 'PromptAndCollect',
            name: 'ChoiceCallBackUser',
            posX: 1202,
            posY: 174,
            customizable: false,
            promptAndCollectEntries: [
              {
                digits: '1',
                nextCid: 38,
                statId: null,
                webType: null
              }
            ],
            nextCid: 0,
            startIndicator: 1,
            repeatIndicator: 0,
            numberOfDigits: 1,
            maxReceiveTime: 60,
            terminateDigit: null,
            firstDigitTime: 10,
            nextDigitTime: 10,
            messageName: '../CB_tast1.wav',
            errorCid: 0,
            toFewDigitsCid: 0,
            disconnectACid: null,
            language: null
          },
          38: {
            '@type': 'PromptModule',
            serviceNumber: '4778974938',
            id: 38,
            type: 'Prompt',
            name: 'callback message',
            posX: 1204,
            posY: 287,
            customizable: false,
            messageName: '../Takk_vi_ringer_deg.wav',
            nextCid: 39,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          39: {
            '@type': 'Component',
            serviceNumber: '4778974938',
            id: 39,
            type: 'CallbackQueue',
            name: 'CallbackQueue',
            posX: 1217,
            posY: 431,
            customizable: false
          },
          40: {
            '@type': 'PromptModule',
            serviceNumber: '4778974938',
            id: 40,
            type: 'Prompt',
            name: 'Bedriftens mobilsvar',
            posX: 386,
            posY: 466,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/LongWaitingTime.wav',
            nextCid: 41,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          41: {
            '@type': 'Component',
            serviceNumber: '4778974938',
            id: 41,
            type: 'Record',
            name: 'record company vmx',
            posX: 415,
            posY: 605,
            customizable: false
          },
          42: {
            '@type': 'SendMessageModule',
            serviceNumber: '4778974938',
            id: 42,
            type: 'SendMessage',
            name: 'Bedriftens mobilsvar',
            posX: 521,
            posY: 607,
            customizable: true,
            protocol: 1,
            delay: 30,
            frequency: 300,
            toAddressExpression: 'dan.lewi.harkestad@@gintel.com',
            fromFullNameExpression: 'Dipper Sentralbord',
            fromAddressExpression: 'ikke-svar@@sb.dipper.no',
            subjectExpression: 'Bedriftens talepostkasse fra Dipper, ny melding fra +@a',
            contentExpression:
              'Du har en melding fra +@a, vennligst se vedlegg.@N@NMeldingen ble mottatt: @D @T@N@NDette er en automatisk generert melding, det er ikke mulig å svare på e-posten.@N@NFor hjelp og tilbakemelding, kontakt kundeservice: https://dipper.no/kundeservice.@N@NHilsen Dipper.',
            attachementPathExpression: '/mnt/rec_share/@a_@B_@d@t.wav',
            daysBeforeExpire: 1,
            nextCid: null,
            errorCid: null
          },
          43: {
            '@type': 'SendSmsModule',
            serviceNumber: '4778974938',
            id: 43,
            type: 'SendSMS',
            name: '43 SendSMS',
            posX: 1345,
            posY: 406,
            customizable: true,
            source: '',
            displaySource: '',
            destination: '@A',
            message: '',
            nextCid: null,
            errorCid: null
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'Svargruppe_91903884',
        number: '4778974972',
        initComponent: 4,
        posX: 10,
        posY: 19,
        installDate: 1588159303000,
        pattern: 2,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1588159303000,
        componentMap: {
          0: {
            '@type': 'QueueModule',
            serviceNumber: '4778974972',
            id: 0,
            type: 'Queue',
            name: 'Svargruppe_91903884',
            posX: 884,
            posY: 19,
            customizable: true,
            messageSequences: [
              {
                seqNo: 1,
                messageName: '../silence.wav',
                description: 'dummy',
                duration: 0,
                variablePhrases: null,
                nextSeqNo: 3
              },
              {
                seqNo: 2,
                messageName: '../welcome.wav',
                description: 'welcome',
                duration: 0,
                variablePhrases: null,
                nextSeqNo: 3
              },
              {
                seqNo: 3,
                messageName: '../ringingtone.wav',
                description: 'music',
                duration: 0,
                variablePhrases: null,
                nextSeqNo: 4
              },
              {
                seqNo: 4,
                messageName: '../periodical.wav',
                description: 'periodical',
                duration: 0,
                variablePhrases: null,
                nextSeqNo: 3
              }
            ],
            queueFullCid: 26,
            kickoutTimeCid: 26,
            kickoutNoAgentsCid: 26,
            ivrErrorCid: null,
            maxPositions: 10,
            maxTime: 300,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 120,
            displayUpdateFrequency: 30,
            bnoAnaOrig: 210,
            noReplyTime: 25,
            chargingString: '511',
            noConnectFlags: 4095,
            agentDisplayMode: 5,
            disconnectACid: null,
            disconnectBCid: null,
            disconnectNotAnsweredCid: null,
            pauseCid: 36,
            pauseTime: 40,
            pauseRepeat: true,
            svcDegreeTime: 60,
            language: null,
            maxConnectTime: null,
            agentWarningTime: null,
            agentIntroMessage: null,
            callerIntroMessage: false,
            transferDisplayMode: null,
            dtmfCharacter: null,
            dtmfInConversationCid: null,
            dtmfInQueueCid: null,
            transferFailedCid: null,
            freeAgentOnTransfer: true,
            recordCall: false,
            recordCallFilename: null,
            agentSearchBackground: true,
            parallel: 0,
            huntType: 2,
            tempUnavailableTimeout: null,
            huntIterations: 1,
            smsWhenLoggOff: '',
            maxMissedCounter: null,
            huntActionMissed: 0,
            transferMessage: null,
            bctDisplayMode: -1,
            huntFailedCid: null,
            rejectCid: 26,
            rejectType: -1,
            genericNumberDisplayExpression: '@G00',
            bctDisplayExpression: '@G00',
            transferDisplayExpression: '@G00',
            alarmTime: 0,
            alarmLength: 0,
            alarmRejectEnabled: false,
            alarmKickoutEnabled: false,
            alarmLastAgentEnabled: false,
            alarmFirstAgentEnabled: false,
            alarmRecipients: '',
            cnumber: '22399126'
          },
          3: {
            '@type': 'QueueModule',
            serviceNumber: '4778974972',
            id: 3,
            type: 'Queue',
            name: 'Holdqueue',
            posX: 825,
            posY: 320,
            customizable: true,
            messageSequences: [
              {
                seqNo: 1,
                messageName: '../ringingtone.wav',
                description: 'music',
                duration: 0,
                variablePhrases: null,
                nextSeqNo: 1
              }
            ],
            queueFullCid: 0,
            kickoutTimeCid: 0,
            kickoutNoAgentsCid: null,
            ivrErrorCid: null,
            maxPositions: 10,
            maxTime: 300,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 9999,
            displayUpdateFrequency: 30,
            bnoAnaOrig: 210,
            noReplyTime: 20,
            chargingString: '511',
            noConnectFlags: 4095,
            agentDisplayMode: 5,
            disconnectACid: null,
            disconnectBCid: null,
            disconnectNotAnsweredCid: null,
            pauseCid: null,
            pauseTime: null,
            pauseRepeat: false,
            svcDegreeTime: 60,
            language: null,
            maxConnectTime: null,
            agentWarningTime: null,
            agentIntroMessage: null,
            callerIntroMessage: false,
            transferDisplayMode: 2,
            dtmfCharacter: null,
            dtmfInConversationCid: null,
            dtmfInQueueCid: null,
            transferFailedCid: null,
            freeAgentOnTransfer: true,
            recordCall: false,
            recordCallFilename: null,
            agentSearchBackground: false,
            parallel: 2,
            huntType: 0,
            tempUnavailableTimeout: 30,
            huntIterations: 1,
            smsWhenLoggOff: '',
            maxMissedCounter: null,
            huntActionMissed: 0,
            transferMessage: null,
            bctDisplayMode: -1,
            huntFailedCid: null,
            rejectCid: null,
            rejectType: null,
            genericNumberDisplayExpression: '@G00',
            bctDisplayExpression: '@G00',
            transferDisplayExpression: '@G00',
            alarmTime: 0,
            alarmLength: 0,
            alarmRejectEnabled: false,
            alarmKickoutEnabled: false,
            alarmLastAgentEnabled: false,
            alarmFirstAgentEnabled: false,
            alarmRecipients: '',
            cnumber: '22399126'
          },
          4: {
            '@type': 'CustomDateModule',
            serviceNumber: '4778974972',
            id: 4,
            type: 'CustomDate',
            name: 'Calendar Holidays',
            posX: 353,
            posY: 19,
            customizable: true,
            dateEntries: [],
            legalNextComponents: [
              {
                cid: 20,
                displayName: null
              }
            ],
            defaultNextCid: 5
          },
          5: {
            '@type': 'TimeRouterModule',
            serviceNumber: '4778974972',
            id: 5,
            type: 'TimeRouter',
            name: 'Opening Hours',
            posX: 551,
            posY: 19,
            customizable: true,
            timeRouterEntries: [
              {
                dayOfWeek: 1,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 2,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 3,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 4,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 5,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 6,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              },
              {
                dayOfWeek: 7,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 35
              }
            ],
            legalNextComponents: [
              {
                cid: 22,
                displayName: null
              },
              {
                cid: 35,
                displayName: null
              }
            ],
            defaultNextCid: 20
          },
          6: {
            '@type': 'PromptModule',
            serviceNumber: '4778974972',
            id: 6,
            type: 'Prompt',
            name: 'Switchboard closed message',
            posX: 68,
            posY: 607,
            customizable: true,
            messageName: '../officeclosed.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          20: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974972',
            id: 20,
            type: 'CustomSwitch',
            name: 'Outside OpeningHours Profile',
            posX: 381,
            posY: 228,
            customizable: true,
            legalNextComponents: [
              {
                cid: 6,
                displayName: 'Closed Announcement'
              },
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: 'Member Voicemail'
              },
              {
                cid: 24,
                displayName: 'Phone number'
              },
              {
                cid: 25,
                displayName: 'Company Extension or Group'
              },
              {
                cid: 31,
                displayName: null
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 6,
            stateCid: null
          },
          22: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974972',
            id: 22,
            type: 'Termination',
            name: 'Choice',
            posX: 626,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4778403123003',
            breleaseCall: false
          },
          23: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974972',
            id: 23,
            type: 'Termination',
            name: 'redirect user vmx on no reply',
            posX: 710,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791509001',
            breleaseCall: false
          },
          24: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974972',
            id: 24,
            type: 'Termination',
            name: 'Redirect external vmx number',
            posX: 822,
            posY: 623,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          25: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974972',
            id: 25,
            type: 'Termination',
            name: 'CompanyExt',
            posX: 261,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 1,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          26: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974972',
            id: 26,
            type: 'CustomSwitch',
            name: 'Overflow Profile',
            posX: 973,
            posY: 343,
            customizable: true,
            legalNextComponents: [
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: 'Member Voicemail'
              },
              {
                cid: 29,
                displayName: 'Closed Announcement'
              },
              {
                cid: 30,
                displayName: 'Phone number'
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 29,
            stateCid: 29
          },
          29: {
            '@type': 'PromptModule',
            serviceNumber: '4778974972',
            id: 29,
            type: 'Prompt',
            name: 'Ubesvart - talemelding',
            posX: 1022,
            posY: 623,
            customizable: true,
            messageName: '../overflow.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          30: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974972',
            id: 30,
            type: 'Termination',
            name: 'Overflow Phonenumber redirect',
            posX: 1124,
            posY: 623,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          31: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974972',
            id: 31,
            type: 'Termination',
            name: 'Different answergroup',
            posX: 0,
            posY: 607,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          32: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974972',
            id: 32,
            type: 'CustomSwitch',
            name: 'Include welcome',
            posX: 693,
            posY: 136,
            customizable: true,
            legalNextComponents: [
              {
                cid: 0,
                displayName: null
              }
            ],
            defaultNextCid: 0,
            stateCid: 33
          },
          33: {
            '@type': 'PromptModule',
            serviceNumber: '4778974972',
            id: 33,
            type: 'Prompt',
            name: 'Welcome message',
            posX: 685,
            posY: 256,
            customizable: true,
            messageName: '../welcome.wav',
            nextCid: 0,
            repeatIndicator: 0,
            errorCid: 0,
            disconnectACid: null,
            language: null,
            early: null
          },
          35: {
            '@type': 'Component',
            serviceNumber: '4778974972',
            id: 35,
            type: 'IntLookup',
            name: 'RedirFromAnotherQueue',
            posX: 670,
            posY: 19,
            customizable: false
          },
          36: {
            '@type': 'Component',
            serviceNumber: '4778974972',
            id: 36,
            type: 'IntLookup',
            name: 'CheckValidANumber',
            posX: 1208,
            posY: 21,
            customizable: false
          },
          37: {
            '@type': 'PromptAndCollectModule',
            serviceNumber: '4778974972',
            id: 37,
            type: 'PromptAndCollect',
            name: 'ChoiceCallBackUser',
            posX: 1202,
            posY: 174,
            customizable: false,
            promptAndCollectEntries: [
              {
                digits: '1',
                nextCid: 38,
                statId: null,
                webType: null
              }
            ],
            nextCid: 0,
            startIndicator: 1,
            repeatIndicator: 0,
            numberOfDigits: 1,
            maxReceiveTime: 60,
            terminateDigit: null,
            firstDigitTime: 10,
            nextDigitTime: 10,
            messageName: '../CB_tast1.wav',
            errorCid: 0,
            toFewDigitsCid: 0,
            disconnectACid: null,
            language: null
          },
          38: {
            '@type': 'PromptModule',
            serviceNumber: '4778974972',
            id: 38,
            type: 'Prompt',
            name: 'callback message',
            posX: 1204,
            posY: 287,
            customizable: false,
            messageName: '../Takk_vi_ringer_deg.wav',
            nextCid: 39,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          39: {
            '@type': 'Component',
            serviceNumber: '4778974972',
            id: 39,
            type: 'CallbackQueue',
            name: 'CallbackQueue',
            posX: 1217,
            posY: 431,
            customizable: false
          },
          40: {
            '@type': 'PromptModule',
            serviceNumber: '4778974972',
            id: 40,
            type: 'Prompt',
            name: 'Bedriftens mobilsvar',
            posX: 386,
            posY: 466,
            customizable: true,
            messageName: '../Bedriftens_VMS.wav',
            nextCid: 41,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          41: {
            '@type': 'Component',
            serviceNumber: '4778974972',
            id: 41,
            type: 'Record',
            name: 'record company vmx',
            posX: 415,
            posY: 605,
            customizable: false
          },
          42: {
            '@type': 'SendMessageModule',
            serviceNumber: '4778974972',
            id: 42,
            type: 'SendMessage',
            name: 'Bedriftens mobilsvar',
            posX: 521,
            posY: 607,
            customizable: true,
            protocol: 1,
            delay: 30,
            frequency: 300,
            toAddressExpression: '',
            fromFullNameExpression: 'Dipper Sentralbord',
            fromAddressExpression: 'ikke-svar@@sb.dipper.no',
            subjectExpression: 'Bedriftens talepostkasse fra Dipper, ny melding fra +@a',
            contentExpression:
              'Du har en melding fra +@a, vennligst se vedlegg.@N@NMeldingen ble mottatt: @D @T@N@NDette er en automatisk generert melding, det er ikke mulig å svare på e-posten.@N@NFor hjelp og tilbakemelding, kontakt kundeservice: https://dipper.no/kundeservice.@N@NHilsen Dipper.',
            attachementPathExpression: '/mnt/rec_share/@a_@B_@d@t.wav',
            daysBeforeExpire: 1,
            nextCid: null,
            errorCid: null
          },
          43: {
            '@type': 'SendSmsModule',
            serviceNumber: '4778974972',
            id: 43,
            type: 'SendSMS',
            name: '43 SendSMS',
            posX: 1345,
            posY: 406,
            customizable: true,
            source: '',
            displaySource: '',
            destination: '@A',
            message: '',
            nextCid: null,
            errorCid: null
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'QueueOverflowTest',
        number: '4778974973',
        initComponent: 4,
        posX: 54,
        posY: 14,
        installDate: 1593438389000,
        pattern: 2,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1592403588000,
        componentMap: {
          0: {
            '@type': 'QueueModule',
            serviceNumber: '4778974973',
            id: 0,
            type: 'Queue',
            name: 'Queue',
            posX: 566,
            posY: 116,
            customizable: true,
            messageSequences: [
              {
                seqNo: 1,
                messageName: '../silence.wav',
                description: 'dummy',
                duration: 0,
                variablePhrases: null,
                nextSeqNo: 2
              },
              {
                seqNo: 2,
                messageName: '../welcome.wav',
                description: 'welcome',
                duration: 0,
                variablePhrases: null,
                nextSeqNo: 3
              },
              {
                seqNo: 3,
                messageName: '../wartemusik1.wav',
                description: 'music',
                duration: 0,
                variablePhrases: null,
                nextSeqNo: 4
              },
              {
                seqNo: 4,
                messageName: '../periodical.wav',
                description: 'periodical',
                duration: 0,
                variablePhrases: null,
                nextSeqNo: 3
              }
            ],
            queueFullCid: 47,
            kickoutTimeCid: 52,
            kickoutNoAgentsCid: 20,
            ivrErrorCid: null,
            maxPositions: 2,
            maxTime: 3000,
            checkFrequency: 30,
            kickoutTime: 300,
            kickoutNoAgents: 30,
            displayUpdateFrequency: 30,
            bnoAnaOrig: 210,
            noReplyTime: 25,
            chargingString: '511',
            noConnectFlags: 4095,
            agentDisplayMode: 5,
            disconnectACid: null,
            disconnectBCid: null,
            disconnectNotAnsweredCid: null,
            pauseCid: null,
            pauseTime: null,
            pauseRepeat: true,
            svcDegreeTime: 60,
            language: null,
            maxConnectTime: null,
            agentWarningTime: null,
            agentIntroMessage: null,
            callerIntroMessage: false,
            transferDisplayMode: 2,
            dtmfCharacter: null,
            dtmfInConversationCid: null,
            dtmfInQueueCid: null,
            transferFailedCid: null,
            freeAgentOnTransfer: true,
            recordCall: false,
            recordCallFilename: null,
            agentSearchBackground: true,
            parallel: 0,
            huntType: 2,
            tempUnavailableTimeout: 30,
            huntIterations: 1,
            smsWhenLoggOff: '',
            maxMissedCounter: null,
            huntActionMissed: 0,
            transferMessage: null,
            bctDisplayMode: -1,
            huntFailedCid: null,
            rejectCid: null,
            rejectType: null,
            genericNumberDisplayExpression: '@G00',
            bctDisplayExpression: '@G00',
            transferDisplayExpression: '@G00',
            alarmTime: 0,
            alarmLength: 0,
            alarmRejectEnabled: false,
            alarmKickoutEnabled: false,
            alarmLastAgentEnabled: false,
            alarmFirstAgentEnabled: false,
            alarmRecipients: '',
            cnumber: '22399126'
          },
          4: {
            '@type': 'CustomDateModule',
            serviceNumber: '4778974973',
            id: 4,
            type: 'CustomDate',
            name: 'CalendarHolidays',
            posX: 233,
            posY: 20,
            customizable: true,
            dateEntries: [],
            legalNextComponents: [],
            defaultNextCid: 5
          },
          5: {
            '@type': 'TimeRouterModule',
            serviceNumber: '4778974973',
            id: 5,
            type: 'TimeRouter',
            name: 'OpeningHours',
            posX: 433,
            posY: 20,
            customizable: true,
            timeRouterEntries: [],
            legalNextComponents: [
              {
                cid: 0,
                displayName: null
              }
            ],
            defaultNextCid: 0
          },
          6: {
            '@type': 'PromptModule',
            serviceNumber: '4778974973',
            id: 6,
            type: 'Prompt',
            name: 'UnstaffedAnnouncement',
            posX: 122,
            posY: 219,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/Ingenagenter.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          20: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974973',
            id: 20,
            type: 'CustomSwitch',
            name: 'UnstaffedProfile',
            posX: 356,
            posY: 219,
            customizable: true,
            legalNextComponents: [
              {
                cid: 6,
                displayName: 'Closed Announcement'
              },
              {
                cid: 25,
                displayName: 'Company Extension or Group'
              },
              {
                cid: 60,
                displayName: null
              }
            ],
            defaultNextCid: 6,
            stateCid: 25
          },
          25: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974973',
            id: 25,
            type: 'Termination',
            name: 'UnstaffedRerouting',
            posX: 347,
            posY: 328,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 10,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: 45,
            busyCid: 45,
            notReachableCid: 45,
            faultCid: 45,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4799362499',
            breleaseCall: false
          },
          44: {
            '@type': 'PromptModule',
            serviceNumber: '4778974973',
            id: 44,
            type: 'Prompt',
            name: 'UnstaffedSecondaryAnno',
            posX: 121,
            posY: 443,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/FwNoSuccess.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          45: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974973',
            id: 45,
            type: 'CustomSwitch',
            name: 'UnstaffedSecondaryAnnoActive',
            posX: 315,
            posY: 444,
            customizable: true,
            legalNextComponents: [
              {
                cid: 44,
                displayName: null
              }
            ],
            defaultNextCid: null,
            stateCid: 44
          },
          46: {
            '@type': 'PromptModule',
            serviceNumber: '4778974973',
            id: 46,
            type: 'Prompt',
            name: 'FullQueueAnnouncement',
            posX: 313,
            posY: 608,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/FullQueue.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          47: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974973',
            id: 47,
            type: 'CustomSwitch',
            name: 'FullQueueProfile',
            posX: 543,
            posY: 608,
            customizable: true,
            legalNextComponents: [
              {
                cid: 46,
                displayName: null
              },
              {
                cid: 49,
                displayName: null
              },
              {
                cid: 62,
                displayName: null
              }
            ],
            defaultNextCid: 46,
            stateCid: 62
          },
          49: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974973',
            id: 49,
            type: 'Termination',
            name: 'FullQueueRerouting',
            posX: 534,
            posY: 729,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: 51,
            busyCid: 51,
            notReachableCid: 51,
            faultCid: 51,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4705000',
            breleaseCall: false
          },
          50: {
            '@type': 'PromptModule',
            serviceNumber: '4778974973',
            id: 50,
            type: 'Prompt',
            name: 'FullQueueSecondaryAnno',
            posX: 312,
            posY: 852,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/FwNoSuccess.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          51: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974973',
            id: 51,
            type: 'CustomSwitch',
            name: 'FullQueueSecondaryAnnoActive',
            posX: 502,
            posY: 852,
            customizable: true,
            legalNextComponents: [
              {
                cid: 50,
                displayName: null
              }
            ],
            defaultNextCid: null,
            stateCid: null
          },
          52: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974973',
            id: 52,
            type: 'CustomSwitch',
            name: 'MaxQueueTimeProfile',
            posX: 902,
            posY: 210,
            customizable: true,
            legalNextComponents: [
              {
                cid: 53,
                displayName: null
              },
              {
                cid: 54,
                displayName: null
              },
              {
                cid: 61,
                displayName: null
              }
            ],
            defaultNextCid: 53,
            stateCid: null
          },
          53: {
            '@type': 'PromptModule',
            serviceNumber: '4778974973',
            id: 53,
            type: 'Prompt',
            name: 'MaxQueueTimeAnnouncement',
            posX: 646,
            posY: 215,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/LongWaitingTime.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          54: {
            '@type': 'TerminationModule',
            serviceNumber: '4778974973',
            id: 54,
            type: 'Termination',
            name: 'MaxQueueTimeRerouting',
            posX: 892,
            posY: 320,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 10,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: 56,
            busyCid: 56,
            notReachableCid: 56,
            faultCid: 56,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4799362499',
            breleaseCall: false
          },
          56: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4778974973',
            id: 56,
            type: 'CustomSwitch',
            name: 'MaxQueueTimeSecondaryAnnoActive',
            posX: 861,
            posY: 447,
            customizable: true,
            legalNextComponents: [
              {
                cid: 57,
                displayName: null
              }
            ],
            defaultNextCid: null,
            stateCid: null
          },
          57: {
            '@type': 'PromptModule',
            serviceNumber: '4778974973',
            id: 57,
            type: 'Prompt',
            name: 'MaxQueueTimeSecondaryAnno',
            posX: 644,
            posY: 446,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/FwNoSuccess.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          60: {
            '@type': 'PromptModule',
            serviceNumber: '4778974973',
            id: 60,
            type: 'Prompt',
            name: 'UnstaffedPrimaryAnnouncement',
            posX: 101,
            posY: 328,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/Ingenagenterfw.wav',
            nextCid: 25,
            repeatIndicator: 0,
            errorCid: 25,
            disconnectACid: null,
            language: null,
            early: null
          },
          61: {
            '@type': 'PromptModule',
            serviceNumber: '4778974973',
            id: 61,
            type: 'Prompt',
            name: 'MaxQueueTimePrimaryAnnouncement',
            posX: 625,
            posY: 323,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/LongWaitingTimeFw.wav',
            nextCid: 54,
            repeatIndicator: 0,
            errorCid: 54,
            disconnectACid: null,
            language: null,
            early: null
          },
          62: {
            '@type': 'PromptModule',
            serviceNumber: '4778974973',
            id: 62,
            type: 'Prompt',
            name: 'FullQueuePrimaryAnnouncement',
            posX: 292,
            posY: 729,
            customizable: true,
            messageName: '../VOLTE_GINTEL_STAGING/FullQueueFw.wav',
            nextCid: 49,
            repeatIndicator: 0,
            errorCid: 49,
            disconnectACid: null,
            language: null,
            early: null
          }
        }
      },
      {
        organization: MockData.organization,
        name: 'MH2',
        number: '4791906218',
        initComponent: 4,
        posX: 7,
        posY: 11,
        installDate: 1623332786000,
        pattern: 1,
        blocked: null,
        cdrStatistics: 0,
        serviceType: 0,
        provider: 'dippersp',
        creationTime: 1623332786000,
        componentMap: {
          0: {
            '@type': 'TerminationModule',
            serviceNumber: '4791906218',
            id: 0,
            type: 'Termination',
            name: 'Default Service',
            posX: 892,
            posY: 9,
            customizable: true,
            displayMode: 5,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4778974938',
            breleaseCall: false
          },
          4: {
            '@type': 'CustomDateModule',
            serviceNumber: '4791906218',
            id: 4,
            type: 'CustomDate',
            name: 'Calendar Holidays',
            posX: 351,
            posY: 11,
            customizable: true,
            dateEntries: [],
            legalNextComponents: [
              {
                cid: 20,
                displayName: null
              }
            ],
            defaultNextCid: 5
          },
          5: {
            '@type': 'TimeRouterModule',
            serviceNumber: '4791906218',
            id: 5,
            type: 'TimeRouter',
            name: 'Opening Hours',
            posX: 549,
            posY: 11,
            customizable: true,
            timeRouterEntries: [
              {
                dayOfWeek: 1,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 2,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 3,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 4,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 5,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 6,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              },
              {
                dayOfWeek: 7,
                startHour: 0,
                startMin: 0,
                duration: 1440,
                nextCid: 43
              }
            ],
            legalNextComponents: [
              {
                cid: 0,
                displayName: null
              },
              {
                cid: 43,
                displayName: null
              }
            ],
            defaultNextCid: 20
          },
          6: {
            '@type': 'PromptModule',
            serviceNumber: '4791906218',
            id: 6,
            type: 'Prompt',
            name: 'Switchboard closed message',
            posX: 139,
            posY: 562,
            customizable: true,
            messageName: '../officeclosed.wav',
            nextCid: null,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          20: {
            '@type': 'CustomSwitchModule',
            serviceNumber: '4791906218',
            id: 20,
            type: 'CustomSwitch',
            name: 'Outside OpeningHours Profile',
            posX: 354,
            posY: 337,
            customizable: true,
            legalNextComponents: [
              {
                cid: 6,
                displayName: 'Closed Announcement'
              },
              {
                cid: 22,
                displayName: 'Auto attendant'
              },
              {
                cid: 23,
                displayName: null
              },
              {
                cid: 24,
                displayName: 'Phone number'
              },
              {
                cid: 25,
                displayName: 'Company Extension or Group'
              },
              {
                cid: 31,
                displayName: null
              },
              {
                cid: 40,
                displayName: null
              }
            ],
            defaultNextCid: 6,
            stateCid: null
          },
          22: {
            '@type': 'TerminationModule',
            serviceNumber: '4791906218',
            id: 22,
            type: 'Termination',
            name: 'Autoattendant',
            posX: 658,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          23: {
            '@type': 'TerminationModule',
            serviceNumber: '4791906218',
            id: 23,
            type: 'Termination',
            name: 'Member Voicemail',
            posX: 762,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: 1,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '4791509001',
            breleaseCall: false
          },
          24: {
            '@type': 'TerminationModule',
            serviceNumber: '4791906218',
            id: 24,
            type: 'Termination',
            name: 'Colleague Number',
            posX: 887,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          25: {
            '@type': 'TerminationModule',
            serviceNumber: '4791906218',
            id: 25,
            type: 'Termination',
            name: 'CompanyExt',
            posX: 318,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          31: {
            '@type': 'TerminationModule',
            serviceNumber: '4791906218',
            id: 31,
            type: 'Termination',
            name: 'Queue',
            posX: 57,
            posY: 562,
            customizable: true,
            displayMode: -1,
            bnoAnaOrig: 0,
            noReplyTime: 200,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -2,
            genericNumberDisplayExpression: null,
            callSetupType: 0,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '',
            breleaseCall: false
          },
          40: {
            '@type': 'PromptModule',
            serviceNumber: '4791906218',
            id: 40,
            type: 'Prompt',
            name: 'CompanyVMMessage',
            posX: 385,
            posY: 465,
            customizable: true,
            messageName: '../Bedriftens_VMS.wav',
            nextCid: 41,
            repeatIndicator: 0,
            errorCid: null,
            disconnectACid: null,
            language: null,
            early: null
          },
          41: {
            '@type': 'Component',
            serviceNumber: '4791906218',
            id: 41,
            type: 'Record',
            name: 'VMRecord',
            posX: 417,
            posY: 611,
            customizable: false
          },
          42: {
            '@type': 'SendMessageModule',
            serviceNumber: '4791906218',
            id: 42,
            type: 'SendMessage',
            name: 'SendEmail',
            posX: 521,
            posY: 607,
            customizable: true,
            protocol: 1,
            delay: 30,
            frequency: 300,
            toAddressExpression: null,
            fromFullNameExpression: 'Dipper Sentralbord',
            fromAddressExpression: 'ikke-svar@@sb.dipper.no',
            subjectExpression: 'Bedriftens talepostkasse fra Dipper, ny melding fra +@a',
            contentExpression:
              'Du har en melding fra +@a som ringte nummer @B, vennligst se vedlegg.@N@NMeldingen ble mottatt: @D @T@N@NDette er en automatisk generert melding, det er ikke mulig å svare på e-posten.@N@NFor hjelp og tilbakemelding, kontakt kundeservice: https://dipper.no/kundeservice.@N@NHilsen Dipper.',
            attachementPathExpression: '/mnt/rec_share/@a_@B_@d@t.wav',
            daysBeforeExpire: 1,
            nextCid: null,
            errorCid: null
          },
          43: {
            '@type': 'Component',
            serviceNumber: '4791906218',
            id: 43,
            type: 'Screen',
            name: 'Screen',
            posX: 913,
            posY: 200,
            customizable: false
          },
          44: {
            '@type': 'TerminationModule',
            serviceNumber: '4791906218',
            id: 44,
            type: 'Termination',
            name: 'Continue',
            posX: 1083,
            posY: 197,
            customizable: false,
            displayMode: 1,
            bnoAnaOrig: 0,
            noReplyTime: 20,
            checkFrequency: 120,
            chargingString: null,
            noReplyCid: null,
            busyCid: null,
            notReachableCid: null,
            faultCid: null,
            noConnectFlags: 4095,
            disconnectACid: null,
            disconnectBCid: null,
            redirectDisplayMode: null,
            redirectNumber: null,
            redirectCounter: -1,
            genericNumberDisplayExpression: null,
            callSetupType: 1,
            suppressRedirectInfo: 0,
            terminalType: null,
            afterCreateSno: null,
            durationLimitExpression: null,
            durationLimitCid: null,
            cnumber: '@e',
            breleaseCall: false
          }
        }
      }
    ];
  }
}
